(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-models-solids-addin"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedAddIn = "None";
var selectedSuctionCup = "No";
var selectedCumTube = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";
var previousCumTube = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }
      
      if (selectedAddIn == "None") {
    price += 0;
  } else if (selectedAddIn.includes("Gemstone")) {
    price += 5;
  } else if (selectedAddIn.includes("Metals")) {
    price += 5;
  } else if (selectedAddIn.includes("Glow")) {
    price += 10;
  }
  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedCumTube == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 30;
        }else{
          price += 20;
        }
      }

      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}

//CumTube Availability Support

function checkCumTube() {

for (const index in cumTubeSupport) {
  
  var model = cumTubeSupport[index];
  var modelName = model["name"] ;
  console.log("Selected Modelt: ",selectedModel );
  console.log("Checking : ",modelName );

  if (modelName == selectedModel){
    if (model.cumTubeAllowed == true) {
      console.log("Cum Tube ALLOWED");
      if (selectedCumTube == "N/A") {
        document.getElementById("standard-cum-tube-div").style.display = "block";
        document.getElementById("cum-tube-na-div").style.display = "none";
        if (previousCumTube == "No"){ document.getElementById("cum-tube-no").click(); } 
        if (previousCumTube == "Yes"){ document.getElementById("cum-tube-yes").click(); } 
      }
      break;
    } else {
      console.log("Cum Tube NOT ALLOWED");
      document.getElementById("standard-cum-tube-div").style.display = "none";
      document.getElementById("cum-tube-na-div").style.display = "block";
      document.getElementById("cum-tube-na").click();
      break;
    }
    
  }else{
    document.getElementById("standard-cum-tube-div").style.display = "none";
    document.getElementById("cum-tube-na-div").style.display = "block";
    document.getElementById("cum-tube-na").click();
  }
}
}


function checkSuctionCup() {

  
if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";

    document.getElementById("suction-cup-na").click();
} else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    document.getElementById("suction-cup-na").click();
} else {

    if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";
      if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
      if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
    }
  
}
}

 $(document).ready(function() {

   colorationPrice = 0;

   setPrice();

    $('#primary-color-selected-text').text($('input[type=radio][name="properties[Primary Color]"]:checked').val());


      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png?v=1669232739";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/animated_Ian2.png?v=1687279890";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-ember").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-ian").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-kaleb").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-talon").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
      case "Ember":
      document.getElementById("size-chart-ember").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Ian":
      document.getElementById("size-chart-ian").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/animated_Ian2.png?v=1687279890";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Kaleb":
      document.getElementById("size-chart-kaleb").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Talon":
      document.getElementById("size-chart-talon").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  checkCumTube();
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});


$('input[type=radio][name="properties[Primary Color]"]').on('change', function() {
  let selectedValue = this.value;
  $('#primary-color-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);

});
  
$('input[type=radio][name="properties[AddIn]"]').on('change', function() {

  let selectedValue = this.value;
  if ($(this).attr('id').includes('gemstone')) {
          $('#gemstone-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);
          $('#metal-selected-text').text('None');
          $('#glow-selected-text').text('None');
      } else if ($(this).attr('id').includes('metal')) {
          $('#metal-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);
          $('#gemstone-selected-text').text('None');
          $('#glow-selected-text').text('None');
      } else if ($(this).attr('id').includes('glow')) {
          $('#glow-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);
          $('#gemstone-selected-text').text('None');
          $('#metal-selected-text').text('None');
      }
      
  selectedAddIn = this.value;
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});


$('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

selectedCumTube = this.value;

if (selectedCumTube != "N/A"){ previousCumTube = selectedCumTube }

checkSuctionCup();

setPrice(); 
});

    
// Glow in the Dark disabled for penetrables function.
function updateGlowOptions() {
  var glowOptions = document.querySelectorAll('input[name="properties[AddIn]"][id^="glow-"]');
  var glowLabels = document.querySelectorAll('label[for^="glow-"]');
  var glowNaText = document.getElementById("glow-na-text");
  
  if (selectedModel === "Serenity" || selectedModel === "Zane Butt") {
    glowOptions.forEach(function(option) {
      option.disabled = true;
      option.checked = false;
    });
    glowLabels.forEach(function(label) {
      label.style.display = "none";
    });
    document.getElementById("glow-selected-text").textContent = "None";
    glowNaText.style.display = "block";
  } else {
    glowOptions.forEach(function(option) {
      option.disabled = false;
    });
    glowLabels.forEach(function(label) {
      label.style.display = "inline-block";
    });
    glowNaText.style.display = "none";
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Initial call to update glow options based on the default selected model
  updateGlowOptions();

  // Update glow options whenever the model is changed
  document.querySelectorAll('input[name="properties[Model]"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      selectedModel = this.value;
      updateGlowOptions();
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["all-models-solids"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();

  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

 $(document).ready(function() {

   colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));


   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png?v=1669232739";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-ember").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-ian").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-kaleb").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-talon").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
      case "Ember":
      document.getElementById("size-chart-ember").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Ian":
      document.getElementById("size-chart-ian").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/Ian-2_copy.jpg";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Kaleb":
      document.getElementById("size-chart-kaleb").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Talon":
      document.getElementById("size-chart-talon").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-24k-Gold"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedCumTube = "No";
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousCumTube = "No";
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedCumTube == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 30;
        }else{
          price += 20;
        }
      }

      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkCumTube() {

  for (const index in cumTubeSupport) {
    
    var model = cumTubeSupport[index];
    var modelName = model["name"] ;
    console.log("Selected Modelt: ",selectedModel );
    console.log("Checking : ",modelName );

    if (modelName == selectedModel){
      if (model.cumTubeAllowed == true) {
        console.log("Cum Tube ALLOWED");
        if (selectedCumTube == "N/A") {
          document.getElementById("standard-cum-tube-div").style.display = "block";
          document.getElementById("cum-tube-na-div").style.display = "none";
          if (previousCumTube == "No"){ document.getElementById("cum-tube-no").click(); } 
          if (previousCumTube == "Yes"){ document.getElementById("cum-tube-yes").click(); } 
        }
        break;
      } else {
        console.log("Cum Tube NOT ALLOWED");
        document.getElementById("standard-cum-tube-div").style.display = "none";
        document.getElementById("cum-tube-na-div").style.display = "block";
        document.getElementById("cum-tube-na").click();
        break;
      }
      
    }else{
      document.getElementById("standard-cum-tube-div").style.display = "none";
      document.getElementById("cum-tube-na-div").style.display = "block";
      document.getElementById("cum-tube-na").click();
    }
  }
}
  

function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();
  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();
  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}
  
function updatePricing() {
  var ele = document.getElementsByName('properties[Model]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedModel = ele[i].value;
    
  }

  //console.log("Selected Model: " + selectedModel);
  
  ele = document.getElementsByName('properties[Size]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedSize = ele[i].value;
  }

  setPrice();
}

 $(document).ready(function() {

   //colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));
   document.getElementById("coloration-0").click();
   document.getElementById("model-1").click();
   document.getElementById("size-mini").click();
   document.getElementById("firmness-medium").click();
   document.getElementById("cum-tube-no").click();
   document.getElementById("suction-cup-no").click();
    
  setInterval(updatePricing, 500);

  checkCumTube();

   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-ian").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-kaleb").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-talon").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Ian":
      document.getElementById("size-chart-ian").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/animated_Ian2.png?v=1687279890";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Kaleb":
      document.getElementById("size-chart-kaleb").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Talon":
      document.getElementById("size-chart-talon").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  checkCumTube();
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});

  $('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

  selectedCumTube = this.value;

  if (selectedCumTube != "N/A"){ previousCumTube = selectedCumTube }

  checkSuctionCup();
  
  setPrice(); 
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-Halloween-colorations-2022"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();

  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

 $(document).ready(function() {

   colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));


   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-coloration-all-models-2"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();

  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

 $(document).ready(function() {

   colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));


   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png?v=1669232739";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-ember").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-ian").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-kaleb").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-talon").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
      case "Ember":
      document.getElementById("size-chart-ember").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Ian":
      document.getElementById("size-chart-ian").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/Ian-2_copy.jpg";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Kaleb":
      document.getElementById("size-chart-kaleb").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Talon":
      document.getElementById("size-chart-talon").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-coloration-all-models-3"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();

  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

 $(document).ready(function() {

   colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));


   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png?v=1669232739";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-ember").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-ian").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-talon").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
      case "Ember":
      document.getElementById("size-chart-ember").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Ian":
      document.getElementById("size-chart-ian").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/Ian-2_copy.jpg";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Talon":
      document.getElementById("size-chart-talon").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-coloration-all-models"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedCumTube = "No";
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousCumTube = "No";
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedCumTube == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 30;
        }else{
          price += 20;
        }
      }

      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkCumTube() {

  for (const index in cumTubeSupport) {
    
    var model = cumTubeSupport[index];
    var modelName = model["name"] ;
    console.log("Selected Modelt: ",selectedModel );
    console.log("Checking : ",modelName );

    if (modelName == selectedModel){
      if (model.cumTubeAllowed == true) {
        console.log("Cum Tube ALLOWED");
        if (selectedCumTube == "N/A") {
          document.getElementById("standard-cum-tube-div").style.display = "block";
          document.getElementById("cum-tube-na-div").style.display = "none";
          if (previousCumTube == "No"){ document.getElementById("cum-tube-no").click(); } 
          if (previousCumTube == "Yes"){ document.getElementById("cum-tube-yes").click(); } 
        }
        break;
      } else {
        console.log("Cum Tube NOT ALLOWED");
        document.getElementById("standard-cum-tube-div").style.display = "none";
        document.getElementById("cum-tube-na-div").style.display = "block";
        document.getElementById("cum-tube-na").click();
        break;
      }
      
    }else{
      document.getElementById("standard-cum-tube-div").style.display = "none";
      document.getElementById("cum-tube-na-div").style.display = "block";
      document.getElementById("cum-tube-na").click();
    }
  }
}
  

function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();
  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();
  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}
  
function updatePricing() {
  var ele = document.getElementsByName('properties[Model]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedModel = ele[i].value;
    
  }

  //console.log("Selected Model: " + selectedModel);
  
  ele = document.getElementsByName('properties[Size]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedSize = ele[i].value;
  }

  setPrice();
}

 $(document).ready(function() {

   //colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));
   document.getElementById("coloration-0").click();
   document.getElementById("model-1").click();
   document.getElementById("size-mini").click();
   document.getElementById("firmness-medium").click();
   document.getElementById("cum-tube-no").click();
   document.getElementById("suction-cup-no").click();
    
  setInterval(updatePricing, 500);

  checkCumTube();

   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-ian").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-kaleb").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-talon").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Ian":
      document.getElementById("size-chart-ian").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/animated_Ian2.png?v=1687279890";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Kaleb":
      document.getElementById("size-chart-kaleb").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
      case "Talon":
      document.getElementById("size-chart-talon").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  checkCumTube();
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});

  $('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

  selectedCumTube = this.value;

  if (selectedCumTube != "N/A"){ previousCumTube = selectedCumTube }

  checkSuctionCup();
  
  setPrice(); 
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-coloration-no-penetrables-dennis"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedCumTube = "No";
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousCumTube = "No";
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedCumTube == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 30;
        }else{
          price += 20;
        }
      }

      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkCumTube() {

  for (const index in cumTubeSupport) {
    
    var model = cumTubeSupport[index];
    var modelName = model["name"] ;
    console.log("Selected Modelt: ",selectedModel );
    console.log("Checking : ",modelName );

    if (modelName == selectedModel){
      if (model.cumTubeAllowed == true) {
        console.log("Cum Tube ALLOWED");
        if (selectedCumTube == "N/A") {
          document.getElementById("standard-cum-tube-div").style.display = "block";
          document.getElementById("cum-tube-na-div").style.display = "none";
          if (previousCumTube == "No"){ document.getElementById("cum-tube-no").click(); } 
          if (previousCumTube == "Yes"){ document.getElementById("cum-tube-yes").click(); } 
        }
        break;
      } else {
        console.log("Cum Tube NOT ALLOWED");
        document.getElementById("standard-cum-tube-div").style.display = "none";
        document.getElementById("cum-tube-na-div").style.display = "block";
        document.getElementById("cum-tube-na").click();
        break;
      }
      
    }else{
      document.getElementById("standard-cum-tube-div").style.display = "none";
      document.getElementById("cum-tube-na-div").style.display = "block";
      document.getElementById("cum-tube-na").click();
    }
  }
}
  

function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();
  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();
  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}
  
function updatePricing() {
  var ele = document.getElementsByName('properties[Model]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedModel = ele[i].value;
    
  }

  //console.log("Selected Model: " + selectedModel);
  
  ele = document.getElementsByName('properties[Size]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedSize = ele[i].value;
  }

  setPrice();
}

 $(document).ready(function() {

   //colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));
   document.getElementById("coloration-0").click();
   document.getElementById("model-1").click();
   document.getElementById("size-mini").click();
   document.getElementById("firmness-medium").click();
   document.getElementById("cum-tube-no").click();
   document.getElementById("suction-cup-no").click();
    
  setInterval(updatePricing, 500);

  checkCumTube();

   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-ian").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-kaleb").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-talon").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Ian":
      document.getElementById("size-chart-ian").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/animated_Ian2.png?v=1687279890";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Kaleb":
      document.getElementById("size-chart-kaleb").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Talon":
      document.getElementById("size-chart-talon").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  checkCumTube();
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});

  $('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

  selectedCumTube = this.value;

  if (selectedCumTube != "N/A"){ previousCumTube = selectedCumTube }

  checkSuctionCup();
  
  setPrice(); 
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-coloration-no-penetrables"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedCumTube = "No";
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousCumTube = "No";
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedCumTube == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 30;
        }else{
          price += 20;
        }
      }

      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkCumTube() {

  for (const index in modelSupport) {
    
    var model = modelSupport[index];
    var modelName = model["name"] ;

    if (modelName == selectedModel){
      if (model.cumTubeAllowed == true) {
        if (selectedCumTube == "N/A") {
          document.getElementById("standard-cum-tube-div").style.display = "block";
          document.getElementById("cum-tube-na-div").style.display = "none";
          if (previousCumTube == "No"){ document.getElementById("cum-tube-no").click(); } 
          if (previousCumTube == "Yes"){ document.getElementById("cum-tube-yes").click(); } 
        }
      } else {
        document.getElementById("standard-cum-tube-div").style.display = "none";
        document.getElementById("cum-tube-na-div").style.display = "block";
        document.getElementById("cum-tube-na").click();
      }
      
    }else{
      document.getElementById("standard-cum-tube-div").style.display = "none";
      document.getElementById("cum-tube-na-div").style.display = "block";
      document.getElementById("cum-tube-na").click();
    }
  }
}

  

function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();
  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();
  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

 
function updatePricing() {
  var ele = document.getElementsByName('properties[Model]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedModel = ele[i].value;
    
  }

  //console.log("Selected Model: " + selectedModel);
  
  ele = document.getElementsByName('properties[Size]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedSize = ele[i].value;
  }

  setPrice();
}
  

 $(document).ready(function() {

   //colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));
    
   document.getElementById("model-1").click();
   document.getElementById("size-mini").click();
   document.getElementById("firmness-medium").click();
   document.getElementById("cum-tube-no").click();
   document.getElementById("suction-cup-no").click();
    
  setInterval(updatePricing, 500);

  checkCumTube();

   setPrice()

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-ember").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-ian").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
    case "Ember":
      document.getElementById("size-chart-ember").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Ian":
      document.getElementById("size-chart-ian").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/Ian-2_copy.jpg";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  checkCumTube();
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});

  $('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

  selectedCumTube = this.value;

  if (selectedCumTube != "N/A"){ previousCumTube = selectedCumTube }

  checkSuctionCup();
  
  setPrice(); 
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-dark-matter"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";

var colorationPrice = 20;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();

  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

 $(document).ready(function() {

   colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));


   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-for-science"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedCumTube = "No";
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousCumTube = "No";
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }

      if (selectedCumTube == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 30;
        }else{
          price += 20;
        }
      }
  
      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkCumTube() {

  for (const index in modelSupport) {
    
    var model = modelSupport[index];
    var modelName = model["name"] ;

    if (modelName == selectedModel){
      if (model.cumTubeAllowed == true) {
        if (selectedCumTube == "N/A") {
          document.getElementById("standard-cum-tube-div").style.display = "block";
          document.getElementById("cum-tube-na-div").style.display = "none";
          if (previousCumTube == "No"){ document.getElementById("cum-tube-no").click(); } 
          if (previousCumTube == "Yes"){ document.getElementById("cum-tube-yes").click(); } 
        }
      } else {
        document.getElementById("standard-cum-tube-div").style.display = "none";
        document.getElementById("cum-tube-na-div").style.display = "block";
        document.getElementById("cum-tube-na").click();
      }
      
    }else{
      document.getElementById("standard-cum-tube-div").style.display = "none";
      document.getElementById("cum-tube-na-div").style.display = "block";
      document.getElementById("cum-tube-na").click();
    }
  }
}
  

function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();
  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();
  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

function updatePricing() {
  var ele = document.getElementsByName('properties[Model]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedModel = ele[i].value;
    
  }

  //console.log("Selected Model: " + selectedModel);
  
  ele = document.getElementsByName('properties[Size]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedSize = ele[i].value;
  }

  setPrice();
}
 

  
  
 $(document).ready(function() {

   //colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));

   document.getElementById("model-1").click();
   document.getElementById("size-mini").click();
   document.getElementById("firmness-medium").click();
   document.getElementById("cum-tube-no").click();
   document.getElementById("suction-cup-no").click();
    
  setInterval(updatePricing, 500);

  checkCumTube();

   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-ember").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-ian").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-kaleb").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-talon").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
    case "Ember":
      document.getElementById("size-chart-ember").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Ian":
      document.getElementById("size-chart-ian").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/animated_Ian2.png?v=1687279890";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Kaleb":
      document.getElementById("size-chart-kaleb").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/KalebInsertable.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Talon":
      document.getElementById("size-chart-talon").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/talon.png?v=1703028700";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 




  checkCumTube();
  
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});

  $('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

  selectedCumTube = this.value;

  if (selectedCumTube != "N/A"){ previousCumTube = selectedCumTube }

  checkSuctionCup();
  
  setPrice(); 
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-jake-palette"]) return;
  try {
    
  


  selectedModel = document.title.split(' – ')[0];
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedCumTube = "No";
var selectedSuctionCup = "No";
var selectedColoration = "For-Science!";
var primaryColor = "#c6c7d0";
var secondaryColor = "#c6c7d0";
var selectedAddIn = "None";
var primaryColorHex = "#d60c16";
var secondaryColorHex = "#d60c16";

previousModel = document.title.split(' – ')[0];
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousCumTube = "No";
var previousSuctionCup = "No";
var previousColoration = "For-Science!";
var previousPrimaryColor = "primary-color-22";
var previousSecondaryColor = "secondary-color-22";
var previousGlow = "glow-none";
var previousAddIn = "glow-none";

var colorationPrice = 0;

function setPrice() {
  var price = 0;
  price += colorationPrice;
  console.log("Model:", selectedModel);

  if (selectedModel == "Serenity") {
    price += 75;
  } else if (selectedModel == "Zane Butt") {
    price += 100;
  } else if (selectedModel == "Jake") {
    if (selectedSize == "Mini") {
      price += 50;
    } else if (selectedSize == "Small") {
      price += 60;
    } else if (selectedSize == "Medium") {
      price += 80;
    } else if (selectedSize == "Large") {
      price += 100;
    } else if (selectedSize == "XL") {
      price += 120;
    }
  } else {
    if (selectedSize == "Mini") {
      price += 65;
    } else if (selectedSize == "Small") {
      price += 85;
    } else if (selectedSize == "Medium") {
      price += 110;
    } else if (selectedSize == "Large") {
      price += 150;
    } else if (selectedSize == "XL") {
      price += 200;
    } else if (selectedSize == "Brooklyn Supreme") {
      price += 400;
    }
  }

  if (selectedAddIn == "None") {
    price += 0;
  } else if (selectedAddIn.includes("Gemstone")) {
    price += 5;
  } else if (selectedAddIn.includes("Metals")) {
    price += 5;
  } else if (selectedAddIn.includes("Glow")) {
    price += 10;
  }

  if (selectedCumTube == "Yes") {
    if (selectedSize == "Brooklyn Supreme") {
      price += 30;
    } else {
      price += 20;
    }
  }

  if (selectedSuctionCup == "Yes") {
    if (selectedSize == "Brooklyn Supreme") {
      price += 10;
    } else {
      price += 5;
    }
  }

  console.log("Price:", price);

  if (price <= 300) {
    document.getElementById("option-0-" + ((price - 50) / 5)).click();
  } else if (price >= 400 && price <= 500) {
    document.getElementById("option-0-" + ((price - 145) / 5)).click();
  } else {
    document.getElementById("option-0-71").click();
  }
}

function checkSuctionCup() {
  if (selectedModel == "Serenity") {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    document.getElementById("suction-cup-na").click();
  } else if (selectedModel == "Zane Butt") {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    document.getElementById("suction-cup-na").click();
  } else if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")) {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    document.getElementById("suction-cup-na").click();
  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    document.getElementById("suction-cup-na").click();
  } else {
    if (selectedSuctionCup == "N/A" && selectedSize != "One Size") {
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";
      if (previousSuctionCup == "No") {
        document.getElementById("suction-cup-no").click();
      }
      if (previousSuctionCup == "Yes") {
        document.getElementById("suction-cup-yes").click();
      }
    }
  }
}

$(document).ready(function() {
  colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));
  selectedModel = document.title.split(' – ')[0];
  previousModel = document.title.split(' – ')[0];

  previousPrimaryColor = "primary-color-22";
  previousSecondaryColor = "secondary-color-22"; 
  previousAddIn = "gemstone-none";

  handleModelChange();
  checkSuctionCup();
  setPrice();
  $(".cls-0").css("fill", primaryColor);
  $(".cls-1").css("fill", secondaryColor);
  $(".cls-2").css("fill", secondaryColor);
  $('#primary-color-selected-text').text($('input[type=radio][name="properties[Primary Color]"]:checked').val());
  $('#secondary-color-selected-text').text($('input[type=radio][name="properties[Secondary Color]"]:checked').val());
  
});

$('input[type=radio][name="properties[Coloration]"]').on('change', function() {
  var selectedRadio = $(this);
  selectedColoration = selectedRadio.val();
  colorationPrice = Number(selectedRadio.attr('data-value') || selectedRadio.attr('data-price'));

  console.log("Selected Coloration:", selectedColoration);
  console.log("Coloration Price:", colorationPrice);
  
  var colorationSvg = document.getElementById("coloration_svg");
  var colorationImage = document.getElementById("colorationImage");
  var buttonSetColorPrimary = document.getElementById("ButtonSet-Color-Primary");
  var buttonSetColorSecondary = document.getElementById("ButtonSet-Color-Secondary");
  var addincontainer = document.getElementById("add-in-container");

  //Colorations with custom color options
  const customColorations = ["Solid Color", "Split Color", "Dynamic Split", "Fade", "Marble"];

  
    // Always hide color pickers for non-custom colorations
    if (!customColorations.includes(selectedColoration)) {
      if (buttonSetColorPrimary) buttonSetColorPrimary.style.display = "none";
      if (buttonSetColorSecondary) buttonSetColorSecondary.style.display = "none";
      if (addincontainer) addincontainer.style.display = "none";
      if (document.getElementById("primary-color-22")) document.getElementById("primary-color-22").click();
      if (document.getElementById("secondary-color-22")) document.getElementById("secondary-color-22").click();
      if (document.getElementById("gemstone-none")) document.getElementById("gemstone-none").click();
    }
    
    
    if (colorationSvg) colorationSvg.style.display = customColorations.includes(selectedColoration) ? "block" : "none";
    if (colorationImage) {
      const hasImage = selectedRadio.attr('coloration-image') && selectedRadio.attr('coloration-image') !== "none";
      colorationImage.style.display = hasImage ? "inline-block" : "none";
      if (hasImage) {
        colorationImage.src = selectedRadio.attr('coloration-image');
      }
    }

    if (selectedColoration === "Solid Color") {
      $(".cls-0").css("fill", primaryColor);
      $("#marble, #base").css("display", "none");
      if (buttonSetColorPrimary) buttonSetColorPrimary.style.display = "block";
      if (buttonSetColorSecondary) buttonSetColorSecondary.style.display = "none";
      if (addincontainer) addincontainer.style.display = "block";
      if (document.getElementById(previousPrimaryColor)) document.getElementById(previousPrimaryColor).click();
      if (document.getElementById("secondary-color-22")) document.getElementById("secondary-color-22").click();
      if (document.getElementById(previousAddIn)) document.getElementById(previousAddIn).click();
    } else if (selectedColoration === "Split Color" || selectedColoration === "Dynamic Split") {
      $(".cls-0").css("fill", primaryColor);
      $(".cls-1, .cls-2").css("fill", secondaryColor);
      $("#marble").css("display", "none");
      $("#base").css("display", "block");
      if (buttonSetColorPrimary) buttonSetColorPrimary.style.display = "block";
      if (buttonSetColorSecondary) buttonSetColorSecondary.style.display = "block";
      if (addincontainer) addincontainer.style.display = "block";
      if (document.getElementById(previousPrimaryColor)) document.getElementById(previousPrimaryColor).click();
      if (document.getElementById(previousSecondaryColor)) document.getElementById(previousSecondaryColor).click();
      if (document.getElementById(previousAddIn)) document.getElementById(previousAddIn).click();
    } else if (selectedColoration === "Fade") {
      $(".cls-0").css("fill", "url(#Gradient)");
      $(".stop1").css("stop-color", primaryColor);
      $(".stop2").css("stop-color", secondaryColor);
      $("#marble, #base").css("display", "none");
      if (buttonSetColorPrimary) buttonSetColorPrimary.style.display = "block";
      if (buttonSetColorSecondary) buttonSetColorSecondary.style.display = "block";
      if (addincontainer) addincontainer.style.display = "block";
      if (document.getElementById(previousPrimaryColor)) document.getElementById(previousPrimaryColor).click();
      if (document.getElementById(previousSecondaryColor)) document.getElementById(previousSecondaryColor).click();
      if (document.getElementById(previousAddIn)) document.getElementById(previousAddIn).click();
    } else if (selectedColoration === "Marble") {
      $(".cls-0").css("fill", primaryColor);
      $(".cls-1, .cls-2").css("fill", secondaryColor);
      $("#base").css("display", "none");
      $("#marble").css("display", "block");
      if (buttonSetColorPrimary) buttonSetColorPrimary.style.display = "block";
      if (buttonSetColorSecondary) buttonSetColorSecondary.style.display = "block";
      if (addincontainer) addincontainer.style.display = "block";
      if (document.getElementById(previousPrimaryColor)) document.getElementById(previousPrimaryColor).click();
      if (document.getElementById(previousSecondaryColor)) document.getElementById(previousSecondaryColor).click();
      if (document.getElementById(previousAddIn)) document.getElementById(previousAddIn).click();
    }
  
  console.log("Primary Color Display:", buttonSetColorPrimary ? buttonSetColorPrimary.style.display : "Element not found");
  console.log("Secondary Color Display:", buttonSetColorSecondary ? buttonSetColorSecondary.style.display : "Element not found");
  
  setPrice();
});

$('input[type=radio][name="properties[Primary Color]"]').on('change', function() {
  let selectedValue = this.value;
  $('#primary-color-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);

  primaryColor = $(this).attr('color-hex');

  if (selectedColoration == "Fade") {
    $(".cls-0").css("fill", "url(#Gradient)");
    $(".stop1").css("stop-color",  $(this).attr('color-hex'));
  } else {
    $(".cls-0").css("fill", $(this).attr('color-hex'));
  }

  if (primaryColor != "primary-color-22") {
    previousPrimaryColor = this.id;
  }
});

$('input[type=radio][name="properties[Secondary Color]"]').on('change', function() {
  let selectedValue = this.value;
  $('#secondary-color-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);

  secondaryColor = $(this).attr('color-hex');

  if (selectedColoration == "Fade") {
    $(".cls-0").css("fill", "url(#Gradient)");
    $(".stop2").css("stop-color",  $(this).attr('color-hex'));
  } else {
    $(".cls-1").css("fill", $(this).attr('color-hex'));
    $(".cls-2").css("fill", $(this).attr('color-hex'));
  }

  if (secondaryColor != "secondary-color-22") {
    previousSecondaryColor = this.id;
  }
});

$('input[type=radio][name="properties[AddIn]"]').on('change', function() {
  let selectedValue = this.value;
  if ($(this).attr('id').includes('gemstone')) {
    $('#gemstone-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);
    $('#metal-selected-text').text('None');
    $('#glow-selected-text').text('None');
  } else if ($(this).attr('id').includes('metal')) {
    $('#metal-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);
    $('#gemstone-selected-text').text('None');
    $('#glow-selected-text').text('None');
  } else if ($(this).attr('id').includes('glow')) {
    $('#glow-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);
    $('#gemstone-selected-text').text('None');
    $('#metal-selected-text').text('None');
  }

  selectedAddIn = this.value;
  if (selectedAddIn != "glow-none" && selectedAddIn != "metal-none" && selectedAddIn != "gemstone-none") {
    previousAddIn = selectedAddIn;
  }

  setPrice();
});

$('input[type=radio][name="properties[Model]"]').on('change', function() {

selectedModel = this.value;

handleModelChange();

});

function handleModelChange() {

  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    
      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
    
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }



  checkSuctionCup();

  setPrice();
};

$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

    if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

      if (selectedModel == "Atlas"){
        if (selectedSize == "Brooklyn Supreme"){
          document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
        }else{
          document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
        }
      }

    checkSuctionCup();

  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});

$('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

  selectedCumTube = this.value;

  checkSuctionCup();
  
  setPrice(); 
});

function reselectPreviousAddIn() {
  var previousAddInElement = document.getElementById(previousAddIn);
  if (previousAddInElement) {
    previousAddInElement.click();
  }
}





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-model-2"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedSuctionCup = "No";
var selectedCumTube = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";
var previousCumTube = "No";

  var primaryColor = "#ffffff";
  var secondaryColor = "#ffffff";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
     


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }

      if (selectedCumTube == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 30;
        }else{
          price += 20;
        }
        
      }

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();

  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

 $(document).ready(function() {

   colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));


   setPrice();

   $(".cls-0").css("fill", primaryColor);
    $(".cls-1").css("fill", secondaryColor);
    $(".cls-2").css("fill", secondaryColor);

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  if ($(this).attr('coloration-image') == "none"){
    document.getElementById("coloration_svg").style.display = "block";
    document.getElementById("colorationImage").style.display = "none";
    

     if (selectedColoration == "Solid Color") {
       $(".cls-0").css("fill", primaryColor);
      $("#marble,#base").css("display", "none");
       document.getElementById("ButtonSet-Color-Primary").style.display = "block";
      document.getElementById("ButtonSet-Color-Secondary").style.display = "none";
    }else if(selectedColoration == "Split Color" || selectedColoration == "Dynamic Split") {
       $(".cls-0").css("fill", primaryColor);
        $(".cls-1").css("fill", secondaryColor);
        $(".cls-2").css("fill", secondaryColor);
      $("#marble").css("display", "none");
      $("#base").css("display", "block");
       document.getElementById("ButtonSet-Color-Primary").style.display = "block";
      document.getElementById("ButtonSet-Color-Secondary").style.display = "block";
    } else if(selectedColoration == "Fade") {
       $(".cls-0").css("fill", "url(#Gradient)");
      $(".stop1").css("stop-color", primaryColor);
      $(".stop2").css("stop-color", secondaryColor);
      $("#marble,#base").css("display", "none");
       document.getElementById("ButtonSet-Color-Primary").style.display = "block";
      document.getElementById("ButtonSet-Color-Secondary").style.display = "block";
    } else if( selectedColoration == "Marble") {
       $(".cls-0").css("fill", primaryColor);
        $(".cls-1").css("fill", secondaryColor);
        $(".cls-2").css("fill", secondaryColor);
      $("#base").css("display", "none");
      $("#marble").css("display", "block");
       document.getElementById("ButtonSet-Color-Primary").style.display = "block";
      document.getElementById("ButtonSet-Color-Secondary").style.display = "block";
    } 
    
  }else{
    document.getElementById("coloration_svg").style.display = "none";
    document.getElementById("colorationImage").style.display = "inline-block";
    document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
    document.getElementById("ButtonSet-Color-Primary").style.display = "none";
    document.getElementById("ButtonSet-Color-Secondary").style.display = "none";


  }

  
  
  setPrice();
});

$('input[type=radio][name="properties[Primary Color]"]').on('change', function() {

    primaryColor = $(this).attr('color-hex');
  
  if (selectedColoration == "Fade") {
    $(".cls-0").css("fill", "url(#Gradient)");
    $(".stop1").css("stop-color",  $(this).attr('color-hex'));
  }else{
    $(".cls-0").css("fill", $(this).attr('color-hex') );
  }
});

$('input[type=radio][name="properties[Secondary Color]"]').on('change', function() {

  secondaryColor = $(this).attr('color-hex');
  
  if (selectedColoration == "Fade") {
    $(".cls-0").css("fill", "url(#Gradient)");
    $(".stop2").css("stop-color",  $(this).attr('color-hex'));
  }else{
    $(".cls-1").css("fill", $(this).attr('color-hex'));
    $(".cls-2").css("fill", $(this).attr('color-hex'));
  }
  
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

  
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});

$('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

  selectedCumTube = this.value;

  if (selectedCumTube != "N/A"){ previousCumTube = selectedCumTube }
  
  setPrice(); 
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-model-palette-brooklyn"]) return;
  try {
    
  


  selectedModel = document.title.split(' – ')[0];
var selectedSize = "Brooklyn Supreme";
var selectedFirmness = "Medium";
var selectedCumTube = "No";
var selectedSuctionCup = "No";
var selectedColoration = "For-Science!";
var primaryColor = "#c6c7d0";
var secondaryColor = "#c6c7d0";
var selectedAddIn = "None";
var primaryColorHex = "#d60c16";
var secondaryColorHex = "#d60c16";

previousModel = document.title.split(' – ')[0];
var previousSize = "Brooklyn Supreme";
var previousFirmness = "Medium";
var previousCumTube = "No";
var previousSuctionCup = "No";
var previousColoration = "For-Science!";
var previousPrimaryColor = "primary-color-22";
var previousSecondaryColor = "secondary-color-22";
var previousGlow = "glow-none";
var previousAddIn = "glow-none";

var colorationPrice = 0;

function setPrice() {
  var price = 0;
  price += colorationPrice;
  console.log("Model:", selectedModel);

  if (selectedModel == "Serenity") {
    price += 75;
  } else if (selectedModel == "Zane Butt") {
    price += 100;
  } else if (selectedModel == "Jake") {
    if (selectedSize == "Mini") {
      price += 50;
    } else if (selectedSize == "Small") {
      price += 60;
    } else if (selectedSize == "Medium") {
      price += 80;
    } else if (selectedSize == "Large") {
      price += 100;
    } else if (selectedSize == "XL") {
      price += 120;
    }
  } else {
    if (selectedSize == "Mini") {
      price += 65;
    } else if (selectedSize == "Small") {
      price += 85;
    } else if (selectedSize == "Medium") {
      price += 110;
    } else if (selectedSize == "Large") {
      price += 150;
    } else if (selectedSize == "XL") {
      price += 200;
    } else if (selectedSize == "Brooklyn Supreme") {
      price += 400;
    }
  }

  if (selectedAddIn == "None") {
    price += 0;
  } else if (selectedAddIn.includes("Gemstone")) {
    price += 5;
  } else if (selectedAddIn.includes("Metals")) {
    price += 5;
  } else if (selectedAddIn.includes("Glow")) {
    price += 10;
  }

  if (selectedCumTube == "Yes") {
    if (selectedSize == "Brooklyn Supreme") {
      price += 30;
    } else {
      price += 20;
    }
  }

  if (selectedSuctionCup == "Yes") {
    if (selectedSize == "Brooklyn Supreme") {
      price += 10;
    } else {
      price += 5;
    }
  }

  console.log("Price:", price);

  if (price <= 300) {
    document.getElementById("option-0-" + ((price - 50) / 5)).click();
  } else if (price >= 400 && price <= 500) {
    document.getElementById("option-0-" + ((price - 145) / 5)).click();
  } else {
    document.getElementById("option-0-71").click();
  }
}

function checkSuctionCup() {
  if (selectedModel == "Serenity") {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    document.getElementById("suction-cup-na").click();
  } else if (selectedModel == "Zane Butt") {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    document.getElementById("suction-cup-na").click();
  } else if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")) {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    document.getElementById("suction-cup-na").click();
  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    document.getElementById("suction-cup-na").click();
  } else {
    if (selectedSuctionCup == "N/A" && selectedSize != "One Size") {
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";
      if (previousSuctionCup == "No") {
        document.getElementById("suction-cup-no").click();
      }
      if (previousSuctionCup == "Yes") {
        document.getElementById("suction-cup-yes").click();
      }
    }
  }
}

$(document).ready(function() {
  colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));
  selectedModel = document.title.split(' – ')[0];
  previousModel = document.title.split(' – ')[0];

  previousPrimaryColor = "primary-color-22";
  previousSecondaryColor = "secondary-color-22"; 
  previousAddIn = "gemstone-none";

  // Force Brooklyn Supreme size selection
  if (window.location.pathname.includes('brooklyn-supreme')) {
  selectedSize = "Brooklyn Supreme";
  previousSize = "Brooklyn Supreme";
  document.getElementById("size-brooklyn-supreme").click();
  }

  handleModelChange();
  $(".cls-0").css("fill", primaryColor);
  $(".cls-1").css("fill", secondaryColor);
  $(".cls-2").css("fill", secondaryColor);
  $('#primary-color-selected-text').text($('input[type=radio][name="properties[Primary Color]"]:checked').val());
  $('#secondary-color-selected-text').text($('input[type=radio][name="properties[Secondary Color]"]:checked').val());
  
});

$('input[type=radio][name="properties[Coloration]"]').on('change', function() {
  var selectedRadio = $(this);
  selectedColoration = selectedRadio.val();
  colorationPrice = Number(selectedRadio.attr('data-value') || selectedRadio.attr('data-price'));

  console.log("Selected Coloration:", selectedColoration);
  console.log("Coloration Price:", colorationPrice);
  
  var colorationSvg = document.getElementById("coloration_svg");
  var colorationImage = document.getElementById("colorationImage");
  var buttonSetColorPrimary = document.getElementById("ButtonSet-Color-Primary");
  var buttonSetColorSecondary = document.getElementById("ButtonSet-Color-Secondary");
  var addincontainer = document.getElementById("add-in-container");

  //Colorations with custom color options
  const customColorations = ["Solid Color", "Split Color", "Dynamic Split", "Fade", "Marble"];

  
    // Always hide color pickers for non-custom colorations
    if (!customColorations.includes(selectedColoration)) {
      if (buttonSetColorPrimary) buttonSetColorPrimary.style.display = "none";
      if (buttonSetColorSecondary) buttonSetColorSecondary.style.display = "none";
      if (addincontainer) addincontainer.style.display = "none";
      if (document.getElementById("primary-color-22")) document.getElementById("primary-color-22").click();
      if (document.getElementById("secondary-color-22")) document.getElementById("secondary-color-22").click();
      if (document.getElementById("gemstone-none")) document.getElementById("gemstone-none").click();
    }
    
    
    if (colorationSvg) colorationSvg.style.display = customColorations.includes(selectedColoration) ? "block" : "none";
    if (colorationImage) {
      const hasImage = selectedRadio.attr('coloration-image') && selectedRadio.attr('coloration-image') !== "none";
      colorationImage.style.display = hasImage ? "inline-block" : "none";
      if (hasImage) {
        colorationImage.src = selectedRadio.attr('coloration-image');
      }
    }

    if (selectedColoration === "Solid Color") {
      $(".cls-0").css("fill", primaryColor);
      $("#marble, #base").css("display", "none");
      if (buttonSetColorPrimary) buttonSetColorPrimary.style.display = "block";
      if (buttonSetColorSecondary) buttonSetColorSecondary.style.display = "none";
      if (addincontainer) addincontainer.style.display = "block";
      if (document.getElementById(previousPrimaryColor)) document.getElementById(previousPrimaryColor).click();
      if (document.getElementById("secondary-color-22")) document.getElementById("secondary-color-22").click();
      if (document.getElementById(previousAddIn)) document.getElementById(previousAddIn).click();
    } else if (selectedColoration === "Split Color" || selectedColoration === "Dynamic Split") {
      $(".cls-0").css("fill", primaryColor);
      $(".cls-1, .cls-2").css("fill", secondaryColor);
      $("#marble").css("display", "none");
      $("#base").css("display", "block");
      if (buttonSetColorPrimary) buttonSetColorPrimary.style.display = "block";
      if (buttonSetColorSecondary) buttonSetColorSecondary.style.display = "block";
      if (addincontainer) addincontainer.style.display = "block";
      if (document.getElementById(previousPrimaryColor)) document.getElementById(previousPrimaryColor).click();
      if (document.getElementById(previousSecondaryColor)) document.getElementById(previousSecondaryColor).click();
      if (document.getElementById(previousAddIn)) document.getElementById(previousAddIn).click();
    } else if (selectedColoration === "Fade") {
      $(".cls-0").css("fill", "url(#Gradient)");
      $(".stop1").css("stop-color", primaryColor);
      $(".stop2").css("stop-color", secondaryColor);
      $("#marble, #base").css("display", "none");
      if (buttonSetColorPrimary) buttonSetColorPrimary.style.display = "block";
      if (buttonSetColorSecondary) buttonSetColorSecondary.style.display = "block";
      if (addincontainer) addincontainer.style.display = "block";
      if (document.getElementById(previousPrimaryColor)) document.getElementById(previousPrimaryColor).click();
      if (document.getElementById(previousSecondaryColor)) document.getElementById(previousSecondaryColor).click();
      if (document.getElementById(previousAddIn)) document.getElementById(previousAddIn).click();
    } else if (selectedColoration === "Marble") {
      $(".cls-0").css("fill", primaryColor);
      $(".cls-1, .cls-2").css("fill", secondaryColor);
      $("#base").css("display", "none");
      $("#marble").css("display", "block");
      if (buttonSetColorPrimary) buttonSetColorPrimary.style.display = "block";
      if (buttonSetColorSecondary) buttonSetColorSecondary.style.display = "block";
      if (addincontainer) addincontainer.style.display = "block";
      if (document.getElementById(previousPrimaryColor)) document.getElementById(previousPrimaryColor).click();
      if (document.getElementById(previousSecondaryColor)) document.getElementById(previousSecondaryColor).click();
      if (document.getElementById(previousAddIn)) document.getElementById(previousAddIn).click();
    }
  
  console.log("Primary Color Display:", buttonSetColorPrimary ? buttonSetColorPrimary.style.display : "Element not found");
  console.log("Secondary Color Display:", buttonSetColorSecondary ? buttonSetColorSecondary.style.display : "Element not found");
  
  setPrice();
});

$('input[type=radio][name="properties[Primary Color]"]').on('change', function() {
  let selectedValue = this.value;
  $('#primary-color-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);

  primaryColor = $(this).attr('color-hex');

  if (selectedColoration == "Fade") {
    $(".cls-0").css("fill", "url(#Gradient)");
    $(".stop1").css("stop-color",  $(this).attr('color-hex'));
  } else {
    $(".cls-0").css("fill", $(this).attr('color-hex'));
  }

  if (primaryColor != "primary-color-22") {
    previousPrimaryColor = this.id;
  }
});

$('input[type=radio][name="properties[Secondary Color]"]').on('change', function() {
  let selectedValue = this.value;
  $('#secondary-color-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);

  secondaryColor = $(this).attr('color-hex');

  if (selectedColoration == "Fade") {
    $(".cls-0").css("fill", "url(#Gradient)");
    $(".stop2").css("stop-color",  $(this).attr('color-hex'));
  } else {
    $(".cls-1").css("fill", $(this).attr('color-hex'));
    $(".cls-2").css("fill", $(this).attr('color-hex'));
  }

  if (secondaryColor != "secondary-color-22") {
    previousSecondaryColor = this.id;
  }
});

$('input[type=radio][name="properties[AddIn]"]').on('change', function() {
  let selectedValue = this.value;
  if ($(this).attr('id').includes('gemstone')) {
    $('#gemstone-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);
    $('#metal-selected-text').text('None');
    $('#glow-selected-text').text('None');
  } else if ($(this).attr('id').includes('metal')) {
    $('#metal-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);
    $('#gemstone-selected-text').text('None');
    $('#glow-selected-text').text('None');
  } else if ($(this).attr('id').includes('glow')) {
    $('#glow-selected-text').text(selectedValue === 'None' ? 'None' : selectedValue);
    $('#gemstone-selected-text').text('None');
    $('#metal-selected-text').text('None');
  }

  selectedAddIn = this.value;
  if (selectedAddIn != "glow-none" && selectedAddIn != "metal-none" && selectedAddIn != "gemstone-none") {
    previousAddIn = selectedAddIn;
  }

  setPrice();
});

$('input[type=radio][name="properties[Model]"]').on('change', function() {

selectedModel = this.value;

handleModelChange();

});

function handleModelChange() {

  if (window.location.pathname.includes('brooklyn-supreme')) {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
    document.getElementById("standard-size-div").style.display = "none";
    document.getElementById("one-size-div").style.display = "none";
    document.getElementById("size-brooklyn-supreme").click();
    document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
  }

  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    
      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
    
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    // Show Brooklyn Supreme option for Atlas, but don't force it
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  } else {
    // For non-Atlas models, hide Brooklyn Supreme and reset if needed
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (selectedSize == 'Brooklyn Supreme') {
      // Reset to previous non-Brooklyn Supreme size
      if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
      if (previousSize == "Small"){ document.getElementById("size-small").click(); }
      if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
      if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
      if (previousSize == "XL"){ document.getElementById("size-xl").click(); }
    }
  }



  checkSuctionCup();

  setPrice();
};

$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

    if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

      if (selectedModel == "Atlas"){
        if (selectedSize == "Brooklyn Supreme"){
          document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
        }else{
          document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
        }
      }

    checkSuctionCup();

  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});

$('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

  selectedCumTube = this.value;

  checkSuctionCup();
  
  setPrice(); 
});

function reselectPreviousAddIn() {
  var previousAddInElement = document.getElementById(previousAddIn);
  if (previousAddInElement) {
    previousAddInElement.click();
  }
}





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-model-palette-wip"]) return;
  try {
    

var isProgrammaticChange = false;

var selectedModel = document.title.split(' – ')[0];
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedExtra = "No";
var selectedSuctionCup = "No";
var selectedColoration = $('input[type=radio][name="properties[Coloration]"]:checked' || "For-Science!").val();
var selectedPrimaryAddIn = "None";
var selectedSecondaryAddIn = "None";
var primaryAddInType = "none";
var secondaryAddInType = "none";
var primaryColorHex = "#c6c7d0";
var secondaryColorHex = "#c6c7d0";
var primaryAddInHex = "#00000000";
var secondaryAddInHex = "#00000000";

var previousModel = document.title.split(' – ')[0];
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousCumTube = "No";
var previousSuctionCup = "No";
var previousColoration = "For-Science!";
var previousPrimaryColor = "primary-color-22";
var previousSecondaryColor = "secondary-color-22";
var previousGlow = "glow-none";
var previousPrimaryAddIn = "primary-gemstone-none";
var previousSecondaryAddIn = "secondary-gemstone-none";

var colorationPrice = 0;

var customColorations = ["Solid Color", "Split Color", "Dynamic Split", "Fade", "Marble"]
var initialColoration = $('input[type=radio][name="properties[Coloration]"]:checked').val();
var accordionSelectors = {
  container: '#accordion-container',
  primaryColor: '#accordion-primary-color',
  secondaryColor: '#accordion-secondary-color'
};

var selectedSignatureVariant = $('input[type=radio][name="Signature Variant"]:checked').val();
var previousSignatureVariant = "None";

var previewContainer = document.getElementById("preview-container-custom");

const ForScience = {
    imageUrls: [
    "https://cdn.shopify.com/s/files/1/1829/9137/files/For-Science-Preview-1.jpg?v=1735694400",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/For-Science-Preview-2.jpg?v=1735694399",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/For-Science-Preview-3.jpg?v=1735694399",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/For-Science-Preview-4.jpg?v=1735694399",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/TTC-May-27-2024-5.jpg?v=1742655466",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/TTC-Mar-22-2025-6.jpg?v=1742655466",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/TTC-Mar-22-2025-7.jpg?v=1742655466"
  ],
  preloadedImages: [],

  preloadImages: function() {
    this.imageUrls.forEach(url => {
      var img = new Image();
      img.src = url;
      this.preloadedImages.push(img);
    });
  },

  getRandomImage: function() {
    var randomIndex = Math.floor(Math.random() * this.preloadedImages.length);
    return this.preloadedImages[randomIndex].src;
  }
};


var preloadedScienceImages = [];

var selectedScienceColors = [];
var previousScienceColors = [];

function getRandomForScienceImage() {
  const randomIndex = Math.floor(Math.random() * preloadedScienceImages.length);
  return preloadedScienceImages[randomIndex].src;
}

function preloadForScienceImages() {
  forScienceImageUrls.forEach(url => {
    const img = new Image();
    img.src = url;
    preloadedScienceImages.push(img);
  });
}


function handleScienceColorsVisibility(selectedColoration) {
  const $scienceAccordion = $('#accordion-science-container');

  if (selectedColoration === 'For-Science!') {
    if (!$scienceAccordion.data('initialized')) {
      new ScienceAccordion('.science-accordion');
      $scienceAccordion.data('initialized', true);
    }
    $scienceAccordion.slideDown(300);
  } else {
    $scienceAccordion.slideUp(300);
  }
}

$('.science-color-checkbox').each(function() {
  $(this).on('change', function() {
    var checkbox = this;

    if (checkbox.checked && selectedScienceColors.length >= 3) {
      checkbox.checked = false;
      return;
    }

    selectedScienceColors = [];
    $('.science-color-checkbox:checked').each(function() {
      selectedScienceColors.push({
        name: this.value,
        hex: $(this).data('colorHex')
      });
    });

    // Update hidden input with final value only
    var scienceColorsValue = selectedScienceColors.map(c => c.name).join(', ');
    $('#science-colors-final').val(scienceColorsValue);
    previousScienceColors = [...selectedScienceColors];

    // Update display
    $('#science-colors-count').text(selectedScienceColors.length);
    $('#science-colors-selected-text').text(
      selectedScienceColors.length > 0 ?
        selectedScienceColors.map(c => c.name).join(', ') :
        'No Colors Selected'
    );

    // Handle checkbox states
    if (selectedScienceColors.length >= 3) {
      $('.science-color-checkbox:not(:checked)').prop('disabled', true);
    } else {
      $('.science-color-checkbox').prop('disabled', false);
    }

    setPrice();

  });
});

class SignatureAccordion {
  constructor(selector) {
    this.element = document.querySelector(selector);
    if (!this.element) {
      console.error('Signature accordion element not found:', selector);
      return;
    }

    this.header = this.element.querySelector('.accordion-header');
    this.panel = this.element.querySelector('.accordion-panel-signatures');
    this.isAnimating = false;
    this.preloadedImages = {};

    if (!this.header || !this.panel) {
      console.error('Required elements not found');
      return;
    }

    // Preload all signature variant images
    this.preloadSignatureImages();
    this.init();
  }

  preloadSignatureImages() {
    const variants = this.element.querySelectorAll('input[name="properties[Signature Variant]"]');

    variants.forEach(variant => {
      const previewImage = variant.getAttribute('preview-image');
      if (previewImage) {
        const img = new Image();
        img.src = previewImage;
        this.preloadedImages[variant.value] = img;
      }
    });
  }

  init() {
    $(this.header).off('click').on('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!this.isAnimating) {
        this.toggle();
      }
    });

    const isExpanded = this.header.getAttribute('aria-expanded') === 'true';
    const icon = this.header.querySelector('.icon');
    $(icon).css('transform', isExpanded ? 'rotate(0deg)' : 'rotate(180deg)');

    // Handle variant selection
    $(this.element).find('input[name="properties[Signature Variant]"]').on('change', (e) => {
      if (isProgrammaticChange) return;

      const selectedVariant = e.target.value;
      $('#signature-variant-selected-text-accordion').text(selectedVariant);

      this.updatePreview(e.target);
      setPrice(); // Update price if needed
    });
  }

  toggle() {
    this.isAnimating = true;
    const isExpanded = this.header.getAttribute('aria-expanded') === 'true';
    this.header.setAttribute('aria-expanded', !isExpanded);

    // Find the icon element
    const icon = this.header.querySelector('.icon');

    if (isExpanded) {
      // When closing: rotate to 0 degrees
      $(icon).css('transform', 'rotate(0deg)');
      $(this.panel).stop(true, true).slideUp(300, () => {
        this.panel.style.display = 'none';
        this.isAnimating = false;
      });
    } else {
      // When opening: rotate to 180 degrees
      $(icon).css('transform', 'rotate(180deg)');
      this.panel.style.display = 'block';
      $(this.panel).stop(true, true).slideDown(300, () => {
        this.isAnimating = false;
      });
    }
  }

  updatePreview(selectedInput) {
    const previewImage = $(selectedInput).attr('preview-image');
    const variant = $(selectedInput).val();

    if (previewImage && $('#colorationImage').length) {
      const $previewContainer = $('#preview-container-custom');
      $previewContainer.css('opacity', '0');

      // Use the preloaded image or wait for it to load
      if (this.preloadedImages[variant] && this.preloadedImages[variant].complete) {
        setTimeout(() => {
          $('#colorationImage').attr('src', previewImage);
          $previewContainer.css('opacity', '1');
        }, 300);
      } else {
        // If not preloaded, load it now and wait for it to complete
        const img = new Image();
        img.onload = () => {
          $('#colorationImage').attr('src', previewImage);
          $previewContainer.css('opacity', '1');
          this.preloadedImages[variant] = img;
        };
        img.src = previewImage;
      }
    }
  }
}

function handleSignatureAccordionVisibility(selectedColoration) {
  const $signatureAccordion = $('#accordion-signature-container');

  if (selectedColoration === "Signature Coloration") {
    // Only initialize and show for Signature Coloration
    if (!$signatureAccordion.data('initialized')) {
      const signatureAccordionInstance = new SignatureAccordion('#accordion-signature-container');
      $signatureAccordion.data('initialized', true);
      $signatureAccordion.data('instance', signatureAccordionInstance);
    }

    // Prepare the preview image
    const $selectedVariant = $('input[name="properties[Signature Variant]"]:checked');
    if ($selectedVariant.length && $selectedVariant.attr('preview-image') && $('#colorationImage').length) {
      const previewImage = $selectedVariant.attr('preview-image');
      $('#colorationImage').attr('src', previewImage);
    }

    $signatureAccordion.slideDown(300);
  } else {
    // Hide for any other coloration
    $signatureAccordion.slideUp(300);
  }
}


class ScienceAccordion {
  constructor(selector) {
    this.element = document.querySelector(selector);
    if (!this.element) {
      console.error('Science accordion element not found:', selector);
      return;
    }

    this.header = this.element.querySelector('.accordion-header');
    this.panel = this.element.querySelector('.accordion-panel');
    this.isAnimating = false;

    if (!this.header || !this.panel) {
      console.error('Required elements not found');
      return;
    }

    this.init();
  }

  init() {
    $(this.header).off('click').on('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!this.isAnimating) {
        this.toggle();
      }
    });
  }

  toggle() {
    this.isAnimating = true;
    const isExpanded = this.header.getAttribute('aria-expanded') === 'true';
    this.header.setAttribute('aria-expanded', !isExpanded);

    if (isExpanded) {
      $(this.panel).stop(true, true).slideUp(300, () => {
        this.panel.hidden = true;
        this.isAnimating = false;
      });
    } else {
      this.panel.hidden = false;
      $(this.panel).stop(true, true).slideDown(300, () => {
        this.isAnimating = false;
      });
    }
  }
}

function handleScienceColorations(selectedColoration) {
  // Make sure checkboxes are clear when not in For-Science! mode
  if (selectedColoration !== 'For-Science!') {
    if (document.querySelector('input[value="For-Science!"]:checked')) {
      // Save current selection before clearing
      previousScienceColors = JSON.parse(JSON.stringify(selectedScienceColors));
    }
    // Reset the UI elements
    selectedScienceColors = [];
    $('#science-colors-final').val('');
    $('.science-color-checkbox').prop('checked', false).prop('disabled', false);
    $('#science-colors-count').text('0');
    $('#science-colors-selected-text').text('No Colors Selected');
    return;
  }

  // Restore previous selections when returning to For-Science! mode
  if (previousScienceColors && previousScienceColors.length > 0) {
    // Clear current selections first
    $('.science-color-checkbox').prop('checked', false);

    // Restore previous selections
    previousScienceColors.forEach(function(colorData) {
      try {
        var escapedName = colorData.name.replace(/"/g, '&quot;');
        $('input.science-color-checkbox[value="' + escapedName + '"]').prop('checked', true);
      } catch (e) {
        console.error('Error restoring science color:', e);
      }
    });

    // Update the UI
    selectedScienceColors = [...previousScienceColors];
    $('#science-colors-count').text(selectedScienceColors.length);
    $('#science-colors-selected-text').text(
      selectedScienceColors.map(c => c.name).join(', ')
    );

    // Update the hidden input
    var scienceColorsValue = selectedScienceColors.map(c => c.name).join(', ');
    $('#science-colors-final').val(scienceColorsValue);

    // Handle checkbox disabling
    if (selectedScienceColors.length >= 3) {
      $('.science-color-checkbox:not(:checked)').prop('disabled', true);
    }
  }
}

function programmaticClick(element) {
  if (!element) return;
  isProgrammaticChange = true;
  element.click();
  isProgrammaticChange = false;
}

function setPrice() {
  var price = 0;
  price += colorationPrice;

  if (selectedColoration === "Signature Coloration") {
    const selectedVariant = $('input[name="properties[Signature Variant]"]:checked');
    if (selectedVariant.length && selectedVariant.attr('data-value')) {
      price += Number(selectedVariant.attr('data-value'));
    }
  }

  if (selectedModel == "Serenity") {
    price += 75;
  } else if (selectedModel == "Zane Butt") {
    price += 100;
  } else if (selectedModel == "Kaleb Butt") {
    price += 100;

  } else if (selectedModel == "Jake") {
    if (selectedSize == "Mini") {
      price += 50;
    } else if (selectedSize == "Small") {
      price += 60;
    } else if (selectedSize == "Medium") {
      price += 80;
    } else if (selectedSize == "Large") {
      price += 100;
    } else if (selectedSize == "XL") {
      price += 120;
    }
  } else {
    if (selectedSize == "Mini") {
      price += 65;
    } else if (selectedSize == "Small") {
      price += 85;
    } else if (selectedSize == "Medium") {
      price += 110;
    } else if (selectedSize == "Large") {
      price += 150;
    } else if (selectedSize == "XL") {
      price += 200;
    } else if (selectedSize == "Brooklyn Supreme") {
      price += 400;
    }
  }

  // Determine highest add-in price
  var addInPrice = 0;
  function getAddInPrice(addInType) {
    if (addInType === "none") return 0;
    if (addInType.includes("glow")) return 10;
    if (addInType.includes("gemstone") || addInType.includes("metal")) return 5;
    return 0;
  }

  var primaryPrice = getAddInPrice(primaryAddInType);
  var secondaryPrice = getAddInPrice(secondaryAddInType);
  addInPrice = Math.max(primaryPrice, secondaryPrice);
  price += addInPrice;

  if (selectedScienceColors && selectedScienceColors.length > 0) {
    const hasGemstoneOrMetal = selectedScienceColors.some(color =>
      color.name.includes('Gemstone') || color.name.includes('Metal')
    );
    if (hasGemstoneOrMetal) {
      price += 5;
    }
  }

  if (selectedExtra == "Yes") {
    if (selectedSize == "Brooklyn Supreme") {
      price += 30;
    } else {
      price += 20;
    }
  }

  if (selectedSuctionCup == "Yes") {
    if (selectedSize == "Brooklyn Supreme") {
      price += 10;
    } else {
      price += 5;
    }
  }

  console.log("Price:", price);

  if (price <= 300) {
    document.getElementById("option-0-" + ((price - 50) / 5)).click();
  } else if (price >= 400 && price <= 500) {
    document.getElementById("option-0-" + ((price - 145) / 5)).click();
  } else {
    programmaticClick(document.getElementById("option-0-71"));
  }
}

function checkSuctionCup() {
  if (selectedModel == "Serenity" || selectedModel == "Zane Butt") {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    programmaticClick(document.getElementById("suction-cup-na"));
    selectedSuctionCup = "N/A";
  } else if (selectedModel == "Kaleb Butt") {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    programmaticClick(document.getElementById("suction-cup-na"));
    selectedSuctionCup = "N/A";
  } else if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")) {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    programmaticClick(document.getElementById("suction-cup-na"));
    selectedSuctionCup = "N/A";
  } else if (selectedExtra == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    programmaticClick(document.getElementById("suction-cup-na"));
    selectedSuctionCup = "N/A";
  } else {
    if ((selectedExtra == "No" || !selectedExtra) && selectedSize != "One Size") {
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";
      if (previousSuctionCup == "No") {
        programmaticClick(document.getElementById("suction-cup-no"));
        selectedSuctionCup = "No";
      } else if (previousSuctionCup == "Yes") {
        programmaticClick(document.getElementById("suction-cup-yes"));
        selectedSuctionCup = "Yes";
      }
    }
  }
  setPrice();
}

$('input[name="properties[Signature Variant]"]').on('change', function() {
  // Get the selected variant name and convert it to handle format
  var selectedVariant = $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-');

  // Hide all descriptions first
  $('.signature-color-accordion-text').hide();

  // Show the matching description
  $('.signature-color-accordion-text[data-variant="' + selectedVariant + '"]').show();
});

$(document).ready(function() {
  try {
    colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value')) || 0;
    selectedModel = document.title.split(' – ')[0];
    previousModel = document.title.split(' – ')[0];
    previousPrimaryColor = "primary-color-22";
    previousSecondaryColor = "secondary-color-22";
    previousPrimaryAddIn = "primary-gemstone-none";
    previousSecondaryAddIn = "secondary-gemstone-none";
    selectedColoration = $('input[type=radio][name="properties[Coloration]"]:checked').val();

    ForScience.preloadImages();

    // Force Brooklyn Supreme size selection
    if (window.location.pathname.includes('brooklyn-supreme')) {
      selectedSize = "Brooklyn Supreme";
      previousSize = "Brooklyn Supreme";
      programmaticClick(document.getElementById("size-brooklyn-supreme"));
    }

    handleAccordionVisibility(selectedColoration);
    handleSignatureAccordionVisibility(selectedColoration);
    selectedSignatureVariant = $('input[name="properties[Signature Variant]"]:checked').val() || "Standard";
    previousSignatureVariant = selectedSignatureVariant;

    handleModelChange();
    $(".solidcolor").css("fill", primaryColorHex);
    $(".basecolor").css("fill", secondaryColorHex);
    $(".marblecolor").css("fill", secondaryColorHex);
    $('#primary-color-selected-text-accordion').text($('input[type=radio][name="properties[Primary Color]"]:checked').val());
    $('#secondary-color-selected-text-accordion').text($('input[type=radio][name="properties[Secondary Color]"]:checked').val());

    $('.accordion').each((i, accordion) => new Accordion(accordion));

    var initialVariant = $('input[name="properties[Signature Variant]"]:checked').val();
    if (initialVariant) {
      var handle = initialVariant.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      $('.signature-color-accordion-text[data-variant="' + handle + '"]').show();
    }

  } catch (error) {
      console.error('Error in document ready:', error);
  }

});


class Accordion {
  constructor(element) {
    this.accordion = element;
    this.headers = element.querySelectorAll('.accordion-header');
    this.init();
  }

  init() {
    $(this.headers).each((i, header) => {
      $(header).on('click', (e) => {
        // Prevent form submission and event bubbling
        e.preventDefault();
        e.stopPropagation();
        this.toggleSection(header);
      });
    });
  }

  toggleSection(header) {
    const $header = $(header);
    const $panel = $header.next('.accordion-panel');
    const isExpanded = $header.attr('aria-expanded') === 'true';

    // Toggle state
    $header.attr('aria-expanded', !isExpanded);

    // Animate panel
    if (isExpanded) {
      $panel.slideUp(300, () => $panel.prop('hidden', true));
    } else {
      $panel.slideDown(300).prop('hidden', false);
    }

    // Rotate icon
    $header.find('.icon').toggleClass('rotate');
  }
}

function handleAccordionVisibility(selectedColoration) {
  const isCustomColoration = customColorations.includes(selectedColoration);
  const $accordionContainer = $(accordionSelectors.container);
  const $primaryAccordion = $(accordionSelectors.primaryColor);
  const $secondaryAccordion = $(accordionSelectors.secondaryColor);

  // First handle visibility
  if (!isCustomColoration) {
    $accordionContainer.hide();
    // Reset to defaults without triggering add-in rules yet
    isProgrammaticChange = true;
    if (document.getElementById("primary-color-22")) {
      document.getElementById("primary-color-22").click();
    }
    if (document.getElementById("secondary-color-22")) {
      document.getElementById("secondary-color-22").click();
    }
    // Reset add-ins after colors
    if (document.getElementById("primary-gemstone-none")) {
      document.getElementById("primary-gemstone-none").click();
      selectedPrimaryAddIn = "None";
      primaryAddInType = "none";
    }
    if (document.getElementById("secondary-gemstone-none")) {
      document.getElementById("secondary-gemstone-none").click();
      selectedSecondaryAddIn = "None";
      secondaryAddInType = "none";
    }
    isProgrammaticChange = false;
    return;
  }

  // Show container for custom colorations
  $accordionContainer.show();

  // Step 1: Set visibility of accordion sections
  if (selectedColoration === "Solid Color") {
    $primaryAccordion.show();
    $secondaryAccordion.hide();
  } else {
    $primaryAccordion.show();
    $secondaryAccordion.show();
  }

  // Step 2: Restore color selections
  isProgrammaticChange = true;
  if (document.getElementById(previousPrimaryColor)) {
    document.getElementById(previousPrimaryColor).click();
  }
  if (selectedColoration !== "Solid Color" && document.getElementById(previousSecondaryColor)) {
    document.getElementById(previousSecondaryColor).click();
  }
  isProgrammaticChange = false;

}

$('input[type=radio][name="properties[Coloration]"]').on('change', function() {
  if (isProgrammaticChange) return;
  var selectedRadio = $(this);
  selectedColoration = selectedRadio.val();
  colorationPrice = Number(selectedRadio.attr('data-value') || selectedRadio.attr('data-price'));

  var previewContainer = document.getElementById("preview-container-custom");
  var colorationSvg = document.getElementById("coloration_svg");
  var colorationImage = document.getElementById("colorationImage");
  var primaryAddInContainer = document.getElementById("primary-add-in-container");
  var secondaryAddInContainer = document.getElementById("secondary-add-in-container");

  handleAccordionVisibility(selectedColoration);
  handleSignatureAccordionVisibility(selectedColoration);
  handleScienceColorsVisibility(selectedColoration);
  handleScienceColorations(selectedColoration);
  handleAddInReselection(selectedColoration);


  if (colorationSvg && colorationImage) {
    const wasCustomColoration = previewContainer.classList.contains('svg-visible');
    const isCustomColoration = customColorations.includes(selectedColoration);

    if (wasCustomColoration !== isCustomColoration || !isCustomColoration) {
      // Fade for SVG-to-image transitions OR image-to-image transitions
      previewContainer.style.opacity = '0';
      setTimeout(() => {
        colorationSvg.style.display = isCustomColoration ? "block" : "none";
        colorationImage.style.display = !isCustomColoration ? "block" : "none";

        // Set appropriate image source
        if (!isCustomColoration) {
          if (selectedColoration === 'For-Science!') {
            colorationImage.src = ForScience.getRandomImage();
          } else if (selectedColoration === 'Signature Coloration') {
            // Use the selected signature variant's preview image
            const selectedVariant = $('input[name="properties[Signature Variant]"]:checked');
            if (selectedVariant.length && selectedVariant.attr('preview-image')) {
              colorationImage.src = selectedVariant.attr('preview-image');
            }
          } else {
            colorationImage.src = selectedRadio.attr('coloration-image');
          }
        }

        previewContainer.style.opacity = '1';

        if (isCustomColoration) {
          previewContainer.classList.add('svg-visible');
        } else {
          previewContainer.classList.remove('svg-visible');
        }
      }, 300);
    } else {
      // Instant switch for SVG-to-SVG transitions only
      colorationSvg.style.display = isCustomColoration ? "block" : "none";
      colorationImage.style.display = !isCustomColoration ? "block" : "none";

      if (isCustomColoration) {
        previewContainer.classList.add('svg-visible');
      } else {
        previewContainer.classList.remove('svg-visible');
      }
    }
  }

  if (selectedColoration === "Solid Color") {
    $(".solidcolor").css("fill", primaryColorHex);
    $("#SparkleGradientSolid .stop1, #SparkleGradientSolid .stop2").css("stop-color", primaryAddInHex);
    $("#solid_addin").css("display", "block");
    $("#marble, #base, #shaft, .solidaddinfade").css("display", "none");
    $("#SparkleGradientBase .stop1, #SparkleGradientBase .stop2, #SparkleGradientMarble .stop1, #SparkleGradientMarble .stop2, #SparkleGradientShaft .stop1, #SparkleGradientShaft .stop2").css("stop-color", "#00000000");
    if (primaryAddInContainer) primaryAddInContainer.style.display = "block";
  } else if (selectedColoration === "Split Color" || selectedColoration === "Dynamic Split") {
  $(".solidcolor").css("fill", primaryColorHex);
  $("#SparkleGradientSolid .stop1, #SparkleGradientSolid .stop2").css("stop-color", primaryAddInHex);
  $("#base, #SparklePatternBase, #solid_addin").css("display", "block");
  $(".basecolor").css("fill", secondaryColorHex);
  // Fix: Change to stop-color
  $("#SparkleGradientBase .stop1, #SparkleGradientBase .stop2").css("stop-color", secondaryAddInHex);
  $("#marble, #shaft, .solidaddinfade").css("display", "none");
  $("#SparkleGradientMarble .stop1, #SparkleGradientMarble .stop2, #SparkleGradientShaft .stop1, #SparkleGradientShaft .stop2").css("stop-color", "#00000000");

    if (primaryAddInContainer) primaryAddInContainer.style.display = "block";
  } else if (selectedColoration === "Fade") {
    $(".solidcolor").css("fill", "url(#Gradient)");
    $(".fadestop1").css("stop-color", primaryColorHex);
    $(".fadestop2").css("stop-color", secondaryColorHex);
    $(".solidaddinfade").css("display", "block");
    $(".addinfadestop1").css("stop-color", primaryAddInHex);
    $(".addinfadestop2").css("stop-color", secondaryAddInHex);
    $("#marble, #base, #shaft, #solid_addin").css("display", "none");
    $("#SparkleGradientSolid .stop1, #SparkleGradientSolid .stop2, #SparkleGradientBase .stop1, #SparkleGradientBase .stop2, #SparkleGradientMarble .stop1, #SparkleGradientMarble .stop2, #SparkleGradientShaft .stop1, #SparkleGradientShaft .stop2").css("stop-color", "#00000000");
    if (primaryAddInContainer) primaryAddInContainer.style.display = "block";
  } else if (selectedColoration === "Marble") {
    $(".solidcolor").css("fill", primaryColorHex);
    $(".marblecolor").css("fill", secondaryColorHex);
    $("#SparkleGradientSolid .stop1, #SparkleGradientSolid .stop2").css("stop-color", primaryAddInHex);
    $("#SparkleGradientMarble .stop1, #SparkleGradientMarble .stop2").css("stop-color", secondaryAddInHex);
    $("#marble, #solid_addin").css("display", "block");
    $("#SparkleGradientBase .stop1, #SparkleGradientBase .stop2, #SparkleGradientShaft .stop1, #SparkleGradientShaft .stop2").css("stop-color", "#00000000");
    $("#base, #shaft, .solidaddinfade").css("display", "none");

    if (primaryAddInContainer) primaryAddInContainer.style.display = "block";
  }

  if (selectedColoration !== "Signature Coloration") {
    // Create a hidden input to override the signature variant
    if (!$('#signature-variant-override').length) {
      $('<input>').attr({
        type: 'hidden',
        id: 'signature-variant-override',
        name: 'properties[Signature Variant]',
        value: ''
      }).appendTo('form.ProductForm');
    }
  } else {
    // Remove the override when switching back to Signature Coloration
    $('#signature-variant-override').remove();
  }

  updateSecondaryAddInOptions(primaryAddInType);

  setPrice();

});

$('form.ProductForm').on('submit', function(e) {
  console.log('Form submission - Signature Variant value:',
    $('input[name="properties[Signature Variant]"]').val());
  console.log('Override input exists:',
    $('#signature-variant-override').length > 0);
});

$('input[type=radio][name="properties[Primary Color]"]').on('change', function() {
  try {
    if (isProgrammaticChange) return;
    let selectedValue = this.value;
    $('#primary-color-selected-text-accordion').text(selectedValue === 'None' ? 'None' : selectedValue);

    primaryColorHex = $(this).attr('color-hex');

    if (selectedColoration == "Fade") {
      $(".solidcolor").css("fill", "url(#Gradient)");
      $(".fadestop1").css("stop-color",  primaryColorHex);
    } else {
      $(".solidcolor").css("fill", $(this).attr('color-hex'));
    }

    previousPrimaryColor = this.id;

  } catch (error) {
    console.error('Error handling primary color change:', error);
  }
});

$('input[type=radio][name="properties[Secondary Color]"]').on('change', function() {
  if (isProgrammaticChange) return;
  let selectedValue = this.value;
  $('#secondary-color-selected-text-accordion').text(selectedValue === 'None' ? 'None' : selectedValue);

  secondaryColorHex = $(this).attr('color-hex');

  if (selectedColoration == "Fade") {
    $(".solidcolor").css("fill", "url(#Gradient)");
    $(".fadestop2").css("stop-color",  $(this).attr('color-hex'));
  } else {
    $(".basecolor").css("fill", $(this).attr('color-hex'));
    $(".marblecolor").css("fill", $(this).attr('color-hex'));
  }

    previousSecondaryColor = this.id;

});

$('input[type=radio][name="properties[Primary AddIn]"]').on('change', function() {
  primaryAddInHex = $(this).attr('color-hex') || "#00000000";
  $("#SparkleGradientSolid .stop1, .addinfadestop1").css("stop-color", primaryAddInHex);
  if (isProgrammaticChange) return;

  primaryAddInType = getAddInTypeFromId(this.id);
  updateSecondaryAddInOptions(primaryAddInType);
  let selectedPrimaryAddInText = this.value.replace(/(Gemstones|Glow|Metals)$/, '').trim();
  let addInType = '';


  if ($(this).attr('id').includes('gemstone')) {
    addInType = 'Gemstone';
  } else if ($(this).attr('id').includes('metal')) {
    addInType = 'Metal';
  } else if ($(this).attr('id').includes('glow')) {
    addInType = 'Glow';
  }

  $('#primary-add-in-selected-text-accordion').text(
    selectedPrimaryAddInText === 'None' ? 'No Add-Ins' : `${addInType}: ${selectedPrimaryAddInText}`
  );

  selectedPrimaryAddIn = this.id;
  previousPrimaryAddIn = selectedPrimaryAddIn;

  setPrice();
});

function getAddInTypeFromId(elementId) {
  // Check for none variants first
  if (elementId.includes('gemstone-none')) return "none";
  if (elementId.includes('metal-none')) return "none";
  if (elementId.includes('glow-none')) return "none";

  // Then check for actual types
  if (elementId.includes('gemstone')) return "gemstone";
  if (elementId.includes('metal')) return "metal";
  if (elementId.includes('glow')) return "glow";

  return "none";
}

function updateSecondaryAddInOptions(primaryType) {
  var secondaryGemInputs = $('input[id^="secondary-gemstone-"]');
  var secondaryMetalInputs = $('input[id^="secondary-metal-"]');
  var secondaryGlowInputs = $('input[id^="secondary-glow-"]');

  // For Split Color and Dynamic Split, allow all combinations
  if (selectedColoration === "Split Color" || selectedColoration === "Dynamic Split") {
    secondaryGemInputs.prop('disabled', false);
    secondaryMetalInputs.prop('disabled', false);
    secondaryGlowInputs.prop('disabled', false);
    return;
  }

  // First disable everything
  secondaryGemInputs.prop('disabled', true);
  secondaryMetalInputs.prop('disabled', true);
  secondaryGlowInputs.prop('disabled', true);

  // Enable based on primary type
  if (primaryType === 'gemstone' || primaryType === 'metal') {
    secondaryGemInputs.prop('disabled', false);
    secondaryMetalInputs.prop('disabled', false);
    secondaryGlowInputs.prop('disabled', true);
  } else if (primaryType === 'glow') {
    // Enable all glows except none
    secondaryGlowInputs.prop('disabled', false);
    $('#secondary-glow-none').prop('disabled', true);

    // Only auto-select matching glow if current selection isn't already a glow
    var currentSecondary = $('input[name="properties[Secondary AddIn]"]:checked');
    if (!currentSecondary.length || !currentSecondary.attr('id').includes('glow')) {
      const primaryGlowId = $('input[name="properties[Primary AddIn]"]:checked').attr('id');
      const matchingSecondaryId = primaryGlowId.replace('primary-', 'secondary-');
      if ($('#' + matchingSecondaryId).length) {
        programmaticClick(document.getElementById(matchingSecondaryId));
      }
    }
  } else if (primaryType === 'none') {
    secondaryGemInputs.prop('disabled', false);
    secondaryMetalInputs.prop('disabled', false);
    secondaryGlowInputs.prop('disabled', false);
  }

  handleSecondaryTypeMismatch(primaryType);
}

function handleSecondaryTypeMismatch(primaryType) {
  // Skip for Split Color and Dynamic Split
  if (selectedColoration === "Split Color" || selectedColoration === "Dynamic Split") {
    return;
  }

  var selectedSecondary = $('input[name="properties[Secondary AddIn]"]:checked');
  if (!selectedSecondary.length) return;

  var currentSecondaryId = selectedSecondary.attr('id');
  var shouldReset = false;

  // Handle glow type mismatches
  if (primaryType === 'glow') {
    if (!currentSecondaryId.includes('glow')) {
      const primaryGlowId = $('input[name="properties[Primary AddIn]"]:checked').attr('id');
      const matchingSecondaryId = primaryGlowId.replace('primary-', 'secondary-');
      programmaticClick(document.getElementById(matchingSecondaryId));
      shouldReset = true;
    }
  } else if (primaryType !== 'glow' && currentSecondaryId.includes('glow')) {
    programmaticClick(document.getElementById('secondary-gemstone-none'));
    shouldReset = true;
  }

  if (shouldReset) {
    console.warn('Add-in type mismatch reset:', primaryType);
}
}

$('input[type=radio][name="properties[Secondary AddIn]"]').on('change', function() {
  secondaryAddInHex = $(this).attr('color-hex') || "#00000000";
  if (selectedColoration === "Marble") {
    $("#SparkleGradientMarble .stop1, #SparkleGradientMarble .stop2").css("stop-color", secondaryAddInHex);
  } else {
    $("#SparkleGradientBase .stop1, #SparkleGradientBase .stop2,  .addinfadestop2").css("stop-color", secondaryAddInHex);
  }
  if (isProgrammaticChange) return;

  secondaryAddInType = getAddInTypeFromId(this.id);
  let selectedSecondaryAddInText = this.value.replace(/(Gemstones|Glow|Metals)$/, '').trim();
  let addInType = '';


  if ($(this).attr('id').includes('gemstone')) {
    addInType = 'Gemstone';
  } else if ($(this).attr('id').includes('metal')) {
    addInType = 'Metal';
  } else if ($(this).attr('id').includes('glow')) {
    addInType = 'Glow';
  }

  $('#secondary-add-in-selected-text-accordion').text(
    selectedSecondaryAddInText === 'None' ? 'No Add-Ins' : `${addInType}: ${selectedSecondaryAddInText}`
  );

  selectedSecondaryAddIn = this.id;
  previousSecondaryAddIn = selectedSecondaryAddIn;

  setPrice();
});

$('input[type=radio][name="properties[Model]"]').on('change', function() {
  if (isProgrammaticChange) return;

selectedModel = this.value;

handleModelChange();

});

function handleModelChange() {

  if (window.location.pathname.includes('brooklyn-supreme')) {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
    document.getElementById("standard-size-div").style.display = "none";
    document.getElementById("one-size-div").style.display = "none";
    programmaticClick(document.getElementById("size-brooklyn-supreme"));
    document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
  }

  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt' || selectedModel == 'Kaleb Butt') {

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"

      programmaticClick(document.getElementById("firmness-super-soft"));
      programmaticClick(document.getElementById("size-penetrable"));
      programmaticClick(document.getElementById("suction-cup-na"));


  }else{

      previousModel = selectedModel;

      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ programmaticClick(document.getElementById("firmness-soft")); }
        if (previousFirmness == "Medium"){ programmaticClick(document.getElementById("firmness-medium")); }
        if (previousFirmness == "Firm"){ programmaticClick(document.getElementById("firmness-firm")); }

        if (previousSize == "Mini"){ programmaticClick(document.getElementById("size-mini")); }
        if (previousSize == "Small"){ programmaticClick(document.getElementById("size-small")); }
        if (previousSize == "Medium"){ programmaticClick(document.getElementById("size-medium")); }
        if (previousSize == "Large"){ programmaticClick(document.getElementById("size-large")); }
        if (previousSize == "XL"){ programmaticClick(document.getElementById("size-xl")); }
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ programmaticClick(document.getElementById("size-brooklyn-supreme")); }

        if (previousSuctionCup == "No"){ programmaticClick(document.getElementById("suction-cup-no")); }
        if (previousSuctionCup == "Yes"){ programmaticClick(document.getElementById("suction-cup-yes")); }

      }


  }

  if (selectedModel == 'Atlas') {
    // Show Brooklyn Supreme option for Atlas, but don't force it
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  } else {
    // For non-Atlas models, hide Brooklyn Supreme and reset if needed
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (selectedSize == 'Brooklyn Supreme') {
      // Reset to previous non-Brooklyn Supreme size
      if (previousSize == "Mini"){ programmaticClick(document.getElementById("size-mini")); }
      if (previousSize == "Small"){ programmaticClick(document.getElementById("size-small")); }
      if (previousSize == "Medium"){ programmaticClick(document.getElementById("size-medium")); }
      if (previousSize == "Large"){ programmaticClick(document.getElementById("size-large")); }
      if (previousSize == "XL"){ programmaticClick(document.getElementById("size-xl")); }
    }
  }



  checkSuctionCup();

  setPrice();
};

$('input[type=radio][name="properties[Size]"]').on('change', function() {
  if (isProgrammaticChange) return;

  selectedSize = this.value;

    if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

      if (selectedModel == "Atlas"){
        if (selectedSize == "Brooklyn Supreme"){
          document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
        }else{
          document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
        }
      }

    checkSuctionCup();

  setPrice();
});

$('input[type=radio][name="properties[Firmness]"]').on('change', function() {
  if (isProgrammaticChange) return;

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }

  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {
  if (isProgrammaticChange) return;

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }

  setPrice();
});

$('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {
  if (isProgrammaticChange) return;

  selectedExtra = this.value;

  checkSuctionCup();

  setPrice();
});

function handleAddInReselection(coloration) {
  if (!customColorations.includes(coloration)) {
    // Reset state variables when switching to non-custom coloration
    selectedPrimaryAddIn = "None";
    selectedSecondaryAddIn = "None";
    primaryAddInType = "none";
    secondaryAddInType = "none";
    return;
  }

  try {
    isProgrammaticChange = true;
    // Restore primary add-in first and update state
    if (previousPrimaryAddIn) {
      selectedPrimaryAddIn = previousPrimaryAddIn;
      primaryAddInType = getAddInTypeFromId(previousPrimaryAddIn);
      const primaryElement = document.getElementById(previousPrimaryAddIn);
      if (primaryElement) {
        primaryElement.click();
        // Let rules update before handling secondary
        setTimeout(() => {
          // Only restore secondary for multi-color options
          if (coloration !== "Solid Color" && previousSecondaryAddIn) {
            selectedSecondaryAddIn = previousSecondaryAddIn;
            secondaryAddInType = getAddInTypeFromId(previousSecondaryAddIn);
            const secondaryElement = document.getElementById(previousSecondaryAddIn);
            if (secondaryElement) {
              secondaryElement.click();
            }
          }
          isProgrammaticChange = false;
          setPrice();
        }, 0);
      }
    }
  } catch (error) {
    console.error('Error in handleAddInReselection:', error);
    isProgrammaticChange = false;
    // Reset state on error
    selectedPrimaryAddIn = "None";
    selectedSecondaryAddIn = "None";
    primaryAddInType = "none";
    secondaryAddInType = "none";
  }
}





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-model-palette"]) return;
  try {
    

var isProgrammaticChange = false;

var selectedModel = document.title.split(' – ')[0];
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedExtra = "No";
var selectedSuctionCup = "No";
var selectedColoration = $('input[type=radio][name="properties[Coloration]"]:checked' || "For-Science!").val();
var selectedPrimaryAddIn = "None";
var selectedSecondaryAddIn = "None";
var primaryAddInType = "none";
var secondaryAddInType = "none";
var primaryColorHex = "#c6c7d0";
var secondaryColorHex = "#c6c7d0";
var primaryAddInHex = "#00000000";
var secondaryAddInHex = "#00000000";

var previousModel = document.title.split(' – ')[0];
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousCumTube = "No";
var previousSuctionCup = "No";
var previousColoration = "For-Science!";
var previousPrimaryColor = "primary-color-22";
var previousSecondaryColor = "secondary-color-22";
var previousGlow = "glow-none";
var previousPrimaryAddIn = "primary-gemstone-none";
var previousSecondaryAddIn = "secondary-gemstone-none";

var colorationPrice = 0;

var customColorations = ["Solid Color", "Split Color", "Dynamic Split", "Fade", "Marble"]
var initialColoration = $('input[type=radio][name="properties[Coloration]"]:checked').val();
var accordionSelectors = {
  container: '#accordion-container',
  primaryColor: '#accordion-primary-color',
  secondaryColor: '#accordion-secondary-color'
};

var selectedSignatureVariant = $('input[type=radio][name="Signature Variant"]:checked').val();
var previousSignatureVariant = "None";

var previewContainer = document.getElementById("preview-container-custom");

const ForScience = {
    imageUrls: [
    "https://cdn.shopify.com/s/files/1/1829/9137/files/For-Science-Preview-1.jpg?v=1735694400",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/For-Science-Preview-2.jpg?v=1735694399",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/For-Science-Preview-3.jpg?v=1735694399",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/For-Science-Preview-4.jpg?v=1735694399",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/TTC-May-27-2024-5.jpg?v=1742655466",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/TTC-Mar-22-2025-6.jpg?v=1742655466",
    "https://cdn.shopify.com/s/files/1/1829/9137/files/TTC-Mar-22-2025-7.jpg?v=1742655466"
  ],
  preloadedImages: [],

  preloadImages: function() {
    this.imageUrls.forEach(url => {
      var img = new Image();
      img.src = url;
      this.preloadedImages.push(img);
    });
  },

  getRandomImage: function() {
    var randomIndex = Math.floor(Math.random() * this.preloadedImages.length);
    return this.preloadedImages[randomIndex].src;
  }
};


var preloadedScienceImages = [];

var selectedScienceColors = [];
var previousScienceColors = [];

function getRandomForScienceImage() {
  const randomIndex = Math.floor(Math.random() * preloadedScienceImages.length);
  return preloadedScienceImages[randomIndex].src;
}

function preloadForScienceImages() {
  forScienceImageUrls.forEach(url => {
    const img = new Image();
    img.src = url;
    preloadedScienceImages.push(img);
  });
}


function handleScienceColorsVisibility(selectedColoration) {
  const $scienceAccordion = $('#accordion-science-container');

  if (selectedColoration === 'For-Science!') {
    if (!$scienceAccordion.data('initialized')) {
      new ScienceAccordion('.science-accordion');
      $scienceAccordion.data('initialized', true);
    }
    $scienceAccordion.slideDown(300);
  } else {
    $scienceAccordion.slideUp(300);
  }
}

$('.science-color-checkbox').each(function() {
  $(this).on('change', function() {
    var checkbox = this;

    if (checkbox.checked && selectedScienceColors.length >= 3) {
      checkbox.checked = false;
      return;
    }

    selectedScienceColors = [];
    $('.science-color-checkbox:checked').each(function() {
      selectedScienceColors.push({
        name: this.value,
        hex: $(this).data('colorHex')
      });
    });

    // Update hidden input with final value only
    var scienceColorsValue = selectedScienceColors.map(c => c.name).join(', ');
    $('#science-colors-final').val(scienceColorsValue);
    previousScienceColors = [...selectedScienceColors];

    // Update display
    $('#science-colors-count').text(selectedScienceColors.length);
    $('#science-colors-selected-text').text(
      selectedScienceColors.length > 0 ?
        selectedScienceColors.map(c => c.name).join(', ') :
        'No Colors Selected'
    );

    // Handle checkbox states
    if (selectedScienceColors.length >= 3) {
      $('.science-color-checkbox:not(:checked)').prop('disabled', true);
    } else {
      $('.science-color-checkbox').prop('disabled', false);
    }

    setPrice();

  });
});

class SignatureAccordion {
  constructor(selector) {
    this.element = document.querySelector(selector);
    if (!this.element) {
      console.error('Signature accordion element not found:', selector);
      return;
    }

    this.header = this.element.querySelector('.accordion-header');
    this.panel = this.element.querySelector('.accordion-panel-signatures');
    this.isAnimating = false;
    this.preloadedImages = {};

    if (!this.header || !this.panel) {
      console.error('Required elements not found');
      return;
    }

    // Preload all signature variant images
    this.preloadSignatureImages();
    this.init();
  }

  preloadSignatureImages() {
    const variants = this.element.querySelectorAll('input[name="properties[Signature Variant]"]');

    variants.forEach(variant => {
      const previewImage = variant.getAttribute('preview-image');
      if (previewImage) {
        const img = new Image();
        img.src = previewImage;
        this.preloadedImages[variant.value] = img;
      }
    });
  }

  init() {
    $(this.header).off('click').on('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!this.isAnimating) {
        this.toggle();
      }
    });

    const isExpanded = this.header.getAttribute('aria-expanded') === 'true';
    const icon = this.header.querySelector('.icon');
    $(icon).css('transform', isExpanded ? 'rotate(0deg)' : 'rotate(180deg)');

    // Handle variant selection
    $(this.element).find('input[name="properties[Signature Variant]"]').on('change', (e) => {
      if (isProgrammaticChange) return;

      const selectedVariant = e.target.value;
      $('#signature-variant-selected-text-accordion').text(selectedVariant);

      this.updatePreview(e.target);
      setPrice(); // Update price if needed
    });
  }

  toggle() {
    this.isAnimating = true;
    const isExpanded = this.header.getAttribute('aria-expanded') === 'true';
    this.header.setAttribute('aria-expanded', !isExpanded);

    // Find the icon element
    const icon = this.header.querySelector('.icon');

    if (isExpanded) {
      // When closing: rotate to 0 degrees
      $(icon).css('transform', 'rotate(0deg)');
      $(this.panel).stop(true, true).slideUp(300, () => {
        this.panel.style.display = 'none';
        this.isAnimating = false;
      });
    } else {
      // When opening: rotate to 180 degrees
      $(icon).css('transform', 'rotate(180deg)');
      this.panel.style.display = 'block';
      $(this.panel).stop(true, true).slideDown(300, () => {
        this.isAnimating = false;
      });
    }
  }

  updatePreview(selectedInput) {
    const previewImage = $(selectedInput).attr('preview-image');
    const variant = $(selectedInput).val();

    if (previewImage && $('#colorationImage').length) {
      const $previewContainer = $('#preview-container-custom');
      $previewContainer.css('opacity', '0');

      // Use the preloaded image or wait for it to load
      if (this.preloadedImages[variant] && this.preloadedImages[variant].complete) {
        setTimeout(() => {
          $('#colorationImage').attr('src', previewImage);
          $previewContainer.css('opacity', '1');
        }, 300);
      } else {
        // If not preloaded, load it now and wait for it to complete
        const img = new Image();
        img.onload = () => {
          $('#colorationImage').attr('src', previewImage);
          $previewContainer.css('opacity', '1');
          this.preloadedImages[variant] = img;
        };
        img.src = previewImage;
      }
    }
  }
}

function handleSignatureAccordionVisibility(selectedColoration) {
  const $signatureAccordion = $('#accordion-signature-container');

  if (selectedColoration === "Signature Coloration") {
    // Only initialize and show for Signature Coloration
    if (!$signatureAccordion.data('initialized')) {
      const signatureAccordionInstance = new SignatureAccordion('#accordion-signature-container');
      $signatureAccordion.data('initialized', true);
      $signatureAccordion.data('instance', signatureAccordionInstance);
    }

    // Prepare the preview image
    const $selectedVariant = $('input[name="properties[Signature Variant]"]:checked');
    if ($selectedVariant.length && $selectedVariant.attr('preview-image') && $('#colorationImage').length) {
      const previewImage = $selectedVariant.attr('preview-image');
      $('#colorationImage').attr('src', previewImage);
    }

    $signatureAccordion.slideDown(300);
  } else {
    // Hide for any other coloration
    $signatureAccordion.slideUp(300);
  }
}


class ScienceAccordion {
  constructor(selector) {
    this.element = document.querySelector(selector);
    if (!this.element) {
      console.error('Science accordion element not found:', selector);
      return;
    }

    this.header = this.element.querySelector('.accordion-header');
    this.panel = this.element.querySelector('.accordion-panel');
    this.isAnimating = false;

    if (!this.header || !this.panel) {
      console.error('Required elements not found');
      return;
    }

    this.init();
  }

  init() {
    $(this.header).off('click').on('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!this.isAnimating) {
        this.toggle();
      }
    });
  }

  toggle() {
    this.isAnimating = true;
    const isExpanded = this.header.getAttribute('aria-expanded') === 'true';
    this.header.setAttribute('aria-expanded', !isExpanded);

    if (isExpanded) {
      $(this.panel).stop(true, true).slideUp(300, () => {
        this.panel.hidden = true;
        this.isAnimating = false;
      });
    } else {
      this.panel.hidden = false;
      $(this.panel).stop(true, true).slideDown(300, () => {
        this.isAnimating = false;
      });
    }
  }
}

function handleScienceColorations(selectedColoration) {
  // Make sure checkboxes are clear when not in For-Science! mode
  if (selectedColoration !== 'For-Science!') {
    if (document.querySelector('input[value="For-Science!"]:checked')) {
      // Save current selection before clearing
      previousScienceColors = JSON.parse(JSON.stringify(selectedScienceColors));
    }
    // Reset the UI elements
    selectedScienceColors = [];
    $('#science-colors-final').val('');
    $('.science-color-checkbox').prop('checked', false).prop('disabled', false);
    $('#science-colors-count').text('0');
    $('#science-colors-selected-text').text('No Colors Selected');
    return;
  }

  // Restore previous selections when returning to For-Science! mode
  if (previousScienceColors && previousScienceColors.length > 0) {
    // Clear current selections first
    $('.science-color-checkbox').prop('checked', false);

    // Restore previous selections
    previousScienceColors.forEach(function(colorData) {
      try {
        var escapedName = colorData.name.replace(/"/g, '&quot;');
        $('input.science-color-checkbox[value="' + escapedName + '"]').prop('checked', true);
      } catch (e) {
        console.error('Error restoring science color:', e);
      }
    });

    // Update the UI
    selectedScienceColors = [...previousScienceColors];
    $('#science-colors-count').text(selectedScienceColors.length);
    $('#science-colors-selected-text').text(
      selectedScienceColors.map(c => c.name).join(', ')
    );

    // Update the hidden input
    var scienceColorsValue = selectedScienceColors.map(c => c.name).join(', ');
    $('#science-colors-final').val(scienceColorsValue);

    // Handle checkbox disabling
    if (selectedScienceColors.length >= 3) {
      $('.science-color-checkbox:not(:checked)').prop('disabled', true);
    }
  }
}

function programmaticClick(element) {
  if (!element) return;
  isProgrammaticChange = true;
  element.click();
  isProgrammaticChange = false;
}

function setPrice() {
  var price = 0;
  price += colorationPrice;

  if (selectedColoration === "Signature Coloration") {
    const selectedVariant = $('input[name="properties[Signature Variant]"]:checked');
    if (selectedVariant.length && selectedVariant.attr('data-value')) {
      price += Number(selectedVariant.attr('data-value'));
    }
  }

  if (selectedModel == "Serenity") {
    price += 75;
  } else if (selectedModel == "Zane Butt") {
    price += 100;
  } else if (selectedModel == "Kaleb Butt") {
    price += 120;

  } else if (selectedModel == "Jake") {
    if (selectedSize == "Mini") {
      price += 50;
    } else if (selectedSize == "Small") {
      price += 60;
    } else if (selectedSize == "Medium") {
      price += 80;
    } else if (selectedSize == "Large") {
      price += 100;
    } else if (selectedSize == "XL") {
      price += 120;
    }
  } else {
    if (selectedSize == "Mini") {
      price += 65;
    } else if (selectedSize == "Small") {
      price += 85;
    } else if (selectedSize == "Medium") {
      price += 110;
    } else if (selectedSize == "Large") {
      price += 150;
    } else if (selectedSize == "XL") {
      price += 200;
    } else if (selectedSize == "Brooklyn Supreme") {
      price += 500;
    }
  }

  // Determine highest add-in price
  var addInPrice = 0;
  function getAddInPrice(addInType) {
    if (addInType === "none") return 0;
    if (addInType.includes("glow")) return 10;
    if (addInType.includes("gemstone") || addInType.includes("metal")) return 5;
    return 0;
  }

  var primaryPrice = getAddInPrice(primaryAddInType);
  var secondaryPrice = getAddInPrice(secondaryAddInType);
  addInPrice = Math.max(primaryPrice, secondaryPrice);
  price += addInPrice;

  if (selectedScienceColors && selectedScienceColors.length > 0) {
    const hasGemstoneOrMetal = selectedScienceColors.some(color =>
      color.name.includes('Gemstone') || color.name.includes('Metal')
    );
    if (hasGemstoneOrMetal) {
      price += 5;
    }
  }

  if (selectedExtra == "Yes") {
    if (selectedSize == "Brooklyn Supreme") {
      price += 30;
    } else {
      price += 20;
    }
  }

  if (selectedSuctionCup == "Yes") {
    if (selectedSize == "Brooklyn Supreme") {
      price += 10;
    } else {
      price += 5;
    }
  }

  console.log("Price:", price);

  if (price <= 300) {
    document.getElementById("option-0-" + ((price - 50) / 5)).click();
  } else if (price >= 400 && price <= 500) {
    document.getElementById("option-0-" + ((price - 145) / 5)).click();
  } else {
    programmaticClick(document.getElementById("option-0-71"));
  }
}

function checkSuctionCup() {
  if (selectedModel == "Serenity" || selectedModel == "Zane Butt") {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    programmaticClick(document.getElementById("suction-cup-na"));
    selectedSuctionCup = "N/A";
  } else if (selectedModel == "Kaleb Butt") {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    programmaticClick(document.getElementById("suction-cup-na"));
    selectedSuctionCup = "N/A";
  } else if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")) {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    programmaticClick(document.getElementById("suction-cup-na"));
    selectedSuctionCup = "N/A";
  } else if (selectedExtra == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
    document.getElementById("standard-suction-cup-div").style.display = "none";
    document.getElementById("suction-cup-na-div").style.display = "block";
    programmaticClick(document.getElementById("suction-cup-na"));
    selectedSuctionCup = "N/A";
  } else {
    if ((selectedExtra == "No" || !selectedExtra) && selectedSize != "One Size") {
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";
      if (previousSuctionCup == "No") {
        programmaticClick(document.getElementById("suction-cup-no"));
        selectedSuctionCup = "No";
      } else if (previousSuctionCup == "Yes") {
        programmaticClick(document.getElementById("suction-cup-yes"));
        selectedSuctionCup = "Yes";
      }
    }
  }
  setPrice();
}

$('input[name="properties[Signature Variant]"]').on('change', function() {
  // Get the selected variant name and convert it to handle format
  var selectedVariant = $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-');

  // Hide all descriptions first
  $('.signature-color-accordion-text').hide();

  // Show the matching description
  $('.signature-color-accordion-text[data-variant="' + selectedVariant + '"]').show();
});

$(document).ready(function() {
  try {
    colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value')) || 0;
    selectedModel = document.title.split(' – ')[0];
    previousModel = document.title.split(' – ')[0];
    previousPrimaryColor = "primary-color-22";
    previousSecondaryColor = "secondary-color-22";
    previousPrimaryAddIn = "primary-gemstone-none";
    previousSecondaryAddIn = "secondary-gemstone-none";
    selectedColoration = $('input[type=radio][name="properties[Coloration]"]:checked').val();

    ForScience.preloadImages();

    // Force Brooklyn Supreme size selection
    if (window.location.pathname.includes('brooklyn-supreme')) {
      selectedSize = "Brooklyn Supreme";
      previousSize = "Brooklyn Supreme";
      programmaticClick(document.getElementById("size-brooklyn-supreme"));
    }

    handleAccordionVisibility(selectedColoration);
    handleSignatureAccordionVisibility(selectedColoration);
    selectedSignatureVariant = $('input[name="properties[Signature Variant]"]:checked').val() || "Standard";
    previousSignatureVariant = selectedSignatureVariant;

    handleModelChange();
    $(".solidcolor").css("fill", primaryColorHex);
    $(".basecolor").css("fill", secondaryColorHex);
    $(".marblecolor").css("fill", secondaryColorHex);
    $('#primary-color-selected-text-accordion').text($('input[type=radio][name="properties[Primary Color]"]:checked').val());
    $('#secondary-color-selected-text-accordion').text($('input[type=radio][name="properties[Secondary Color]"]:checked').val());

    $('.accordion').each((i, accordion) => new Accordion(accordion));

    var initialVariant = $('input[name="properties[Signature Variant]"]:checked').val();
    if (initialVariant) {
      var handle = initialVariant.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      $('.signature-color-accordion-text[data-variant="' + handle + '"]').show();
    }

  } catch (error) {
      console.error('Error in document ready:', error);
  }

});


class Accordion {
  constructor(element) {
    this.accordion = element;
    this.headers = element.querySelectorAll('.accordion-header');
    this.init();
  }

  init() {
    $(this.headers).each((i, header) => {
      $(header).on('click', (e) => {
        // Prevent form submission and event bubbling
        e.preventDefault();
        e.stopPropagation();
        this.toggleSection(header);
      });
    });
  }

  toggleSection(header) {
    const $header = $(header);
    const $panel = $header.next('.accordion-panel');
    const isExpanded = $header.attr('aria-expanded') === 'true';

    // Toggle state
    $header.attr('aria-expanded', !isExpanded);

    // Animate panel
    if (isExpanded) {
      $panel.slideUp(300, () => $panel.prop('hidden', true));
    } else {
      $panel.slideDown(300).prop('hidden', false);
    }

    // Rotate icon
    $header.find('.icon').toggleClass('rotate');
  }
}

function handleAccordionVisibility(selectedColoration) {
  const isCustomColoration = customColorations.includes(selectedColoration);
  const $accordionContainer = $(accordionSelectors.container);
  const $primaryAccordion = $(accordionSelectors.primaryColor);
  const $secondaryAccordion = $(accordionSelectors.secondaryColor);

  // First handle visibility
  if (!isCustomColoration) {
    $accordionContainer.hide();
    // Reset to defaults without triggering add-in rules yet
    isProgrammaticChange = true;
    if (document.getElementById("primary-color-22")) {
      document.getElementById("primary-color-22").click();
    }
    if (document.getElementById("secondary-color-22")) {
      document.getElementById("secondary-color-22").click();
    }
    // Reset add-ins after colors
    if (document.getElementById("primary-gemstone-none")) {
      document.getElementById("primary-gemstone-none").click();
      selectedPrimaryAddIn = "None";
      primaryAddInType = "none";
    }
    if (document.getElementById("secondary-gemstone-none")) {
      document.getElementById("secondary-gemstone-none").click();
      selectedSecondaryAddIn = "None";
      secondaryAddInType = "none";
    }
    isProgrammaticChange = false;
    return;
  }

  // Show container for custom colorations
  $accordionContainer.show();

  // Step 1: Set visibility of accordion sections
  if (selectedColoration === "Solid Color") {
    $primaryAccordion.show();
    $secondaryAccordion.hide();
  } else {
    $primaryAccordion.show();
    $secondaryAccordion.show();
  }

  // Step 2: Restore color selections
  isProgrammaticChange = true;
  if (document.getElementById(previousPrimaryColor)) {
    document.getElementById(previousPrimaryColor).click();
  }
  if (selectedColoration !== "Solid Color" && document.getElementById(previousSecondaryColor)) {
    document.getElementById(previousSecondaryColor).click();
  }
  isProgrammaticChange = false;

}

$('input[type=radio][name="properties[Coloration]"]').on('change', function() {
  if (isProgrammaticChange) return;
  var selectedRadio = $(this);
  selectedColoration = selectedRadio.val();
  colorationPrice = Number(selectedRadio.attr('data-value') || selectedRadio.attr('data-price'));

  var previewContainer = document.getElementById("preview-container-custom");
  var colorationSvg = document.getElementById("coloration_svg");
  var colorationImage = document.getElementById("colorationImage");
  var primaryAddInContainer = document.getElementById("primary-add-in-container");
  var secondaryAddInContainer = document.getElementById("secondary-add-in-container");

  handleAccordionVisibility(selectedColoration);
  handleSignatureAccordionVisibility(selectedColoration);
  handleScienceColorsVisibility(selectedColoration);
  handleScienceColorations(selectedColoration);
  handleAddInReselection(selectedColoration);


  if (colorationSvg && colorationImage) {
    const wasCustomColoration = previewContainer.classList.contains('svg-visible');
    const isCustomColoration = customColorations.includes(selectedColoration);

    if (wasCustomColoration !== isCustomColoration || !isCustomColoration) {
      // Fade for SVG-to-image transitions OR image-to-image transitions
      previewContainer.style.opacity = '0';
      setTimeout(() => {
        colorationSvg.style.display = isCustomColoration ? "block" : "none";
        colorationImage.style.display = !isCustomColoration ? "block" : "none";

        // Set appropriate image source
        if (!isCustomColoration) {
          if (selectedColoration === 'For-Science!') {
            colorationImage.src = ForScience.getRandomImage();
          } else if (selectedColoration === 'Signature Coloration') {
            // Use the selected signature variant's preview image
            const selectedVariant = $('input[name="properties[Signature Variant]"]:checked');
            if (selectedVariant.length && selectedVariant.attr('preview-image')) {
              colorationImage.src = selectedVariant.attr('preview-image');
            }
          } else {
            colorationImage.src = selectedRadio.attr('coloration-image');
          }
        }

        previewContainer.style.opacity = '1';

        if (isCustomColoration) {
          previewContainer.classList.add('svg-visible');
        } else {
          previewContainer.classList.remove('svg-visible');
        }
      }, 300);
    } else {
      // Instant switch for SVG-to-SVG transitions only
      colorationSvg.style.display = isCustomColoration ? "block" : "none";
      colorationImage.style.display = !isCustomColoration ? "block" : "none";

      if (isCustomColoration) {
        previewContainer.classList.add('svg-visible');
      } else {
        previewContainer.classList.remove('svg-visible');
      }
    }
  }

  if (selectedColoration === "Solid Color") {
    $(".solidcolor").css("fill", primaryColorHex);
    $("#SparkleGradientSolid .stop1, #SparkleGradientSolid .stop2").css("stop-color", primaryAddInHex);
    $("#solid_addin").css("display", "block");
    $("#marble, #base, #shaft, .solidaddinfade").css("display", "none");
    $("#SparkleGradientBase .stop1, #SparkleGradientBase .stop2, #SparkleGradientMarble .stop1, #SparkleGradientMarble .stop2, #SparkleGradientShaft .stop1, #SparkleGradientShaft .stop2").css("stop-color", "#00000000");
    if (primaryAddInContainer) primaryAddInContainer.style.display = "block";
  } else if (selectedColoration === "Split Color" || selectedColoration === "Dynamic Split") {
  $(".solidcolor").css("fill", primaryColorHex);
  $("#SparkleGradientSolid .stop1, #SparkleGradientSolid .stop2").css("stop-color", primaryAddInHex);
  $("#base, #SparklePatternBase, #solid_addin").css("display", "block");
  $(".basecolor").css("fill", secondaryColorHex);
  // Fix: Change to stop-color
  $("#SparkleGradientBase .stop1, #SparkleGradientBase .stop2").css("stop-color", secondaryAddInHex);
  $("#marble, #shaft, .solidaddinfade").css("display", "none");
  $("#SparkleGradientMarble .stop1, #SparkleGradientMarble .stop2, #SparkleGradientShaft .stop1, #SparkleGradientShaft .stop2").css("stop-color", "#00000000");

    if (primaryAddInContainer) primaryAddInContainer.style.display = "block";
  } else if (selectedColoration === "Fade") {
    $(".solidcolor").css("fill", "url(#Gradient)");
    $(".fadestop1").css("stop-color", primaryColorHex);
    $(".fadestop2").css("stop-color", secondaryColorHex);
    $(".solidaddinfade").css("display", "block");
    $(".addinfadestop1").css("stop-color", primaryAddInHex);
    $(".addinfadestop2").css("stop-color", secondaryAddInHex);
    $("#marble, #base, #shaft, #solid_addin").css("display", "none");
    $("#SparkleGradientSolid .stop1, #SparkleGradientSolid .stop2, #SparkleGradientBase .stop1, #SparkleGradientBase .stop2, #SparkleGradientMarble .stop1, #SparkleGradientMarble .stop2, #SparkleGradientShaft .stop1, #SparkleGradientShaft .stop2").css("stop-color", "#00000000");
    if (primaryAddInContainer) primaryAddInContainer.style.display = "block";
  } else if (selectedColoration === "Marble") {
    $(".solidcolor").css("fill", primaryColorHex);
    $(".marblecolor").css("fill", secondaryColorHex);
    $("#SparkleGradientSolid .stop1, #SparkleGradientSolid .stop2").css("stop-color", primaryAddInHex);
    $("#SparkleGradientMarble .stop1, #SparkleGradientMarble .stop2").css("stop-color", secondaryAddInHex);
    $("#marble, #solid_addin").css("display", "block");
    $("#SparkleGradientBase .stop1, #SparkleGradientBase .stop2, #SparkleGradientShaft .stop1, #SparkleGradientShaft .stop2").css("stop-color", "#00000000");
    $("#base, #shaft, .solidaddinfade").css("display", "none");

    if (primaryAddInContainer) primaryAddInContainer.style.display = "block";
  }

  if (selectedColoration !== "Signature Coloration") {
    // Create a hidden input to override the signature variant
    if (!$('#signature-variant-override').length) {
      $('<input>').attr({
        type: 'hidden',
        id: 'signature-variant-override',
        name: 'properties[Signature Variant]',
        value: ''
      }).appendTo('form.ProductForm');
    }
  } else {
    // Remove the override when switching back to Signature Coloration
    $('#signature-variant-override').remove();
  }

  updateSecondaryAddInOptions(primaryAddInType);

  setPrice();

});

$('form.ProductForm').on('submit', function(e) {
  console.log('Form submission - Signature Variant value:',
    $('input[name="properties[Signature Variant]"]').val());
  console.log('Override input exists:',
    $('#signature-variant-override').length > 0);
});

$('input[type=radio][name="properties[Primary Color]"]').on('change', function() {
  try {
    if (isProgrammaticChange) return;
    let selectedValue = this.value;
    $('#primary-color-selected-text-accordion').text(selectedValue === 'None' ? 'None' : selectedValue);

    primaryColorHex = $(this).attr('color-hex');

    if (selectedColoration == "Fade") {
      $(".solidcolor").css("fill", "url(#Gradient)");
      $(".fadestop1").css("stop-color",  primaryColorHex);
    } else {
      $(".solidcolor").css("fill", $(this).attr('color-hex'));
    }

    previousPrimaryColor = this.id;

  } catch (error) {
    console.error('Error handling primary color change:', error);
  }
});

$('input[type=radio][name="properties[Secondary Color]"]').on('change', function() {
  if (isProgrammaticChange) return;
  let selectedValue = this.value;
  $('#secondary-color-selected-text-accordion').text(selectedValue === 'None' ? 'None' : selectedValue);

  secondaryColorHex = $(this).attr('color-hex');

  if (selectedColoration == "Fade") {
    $(".solidcolor").css("fill", "url(#Gradient)");
    $(".fadestop2").css("stop-color",  $(this).attr('color-hex'));
  } else {
    $(".basecolor").css("fill", $(this).attr('color-hex'));
    $(".marblecolor").css("fill", $(this).attr('color-hex'));
  }

    previousSecondaryColor = this.id;

});

$('input[type=radio][name="properties[Primary AddIn]"]').on('change', function() {
  primaryAddInHex = $(this).attr('color-hex') || "#00000000";
  $("#SparkleGradientSolid .stop1, .addinfadestop1").css("stop-color", primaryAddInHex);
  if (isProgrammaticChange) return;

  primaryAddInType = getAddInTypeFromId(this.id);
  updateSecondaryAddInOptions(primaryAddInType);
  let selectedPrimaryAddInText = this.value.replace(/(Gemstones|Glow|Metals)$/, '').trim();
  let addInType = '';


  if ($(this).attr('id').includes('gemstone')) {
    addInType = 'Gemstone';
  } else if ($(this).attr('id').includes('metal')) {
    addInType = 'Metal';
  } else if ($(this).attr('id').includes('glow')) {
    addInType = 'Glow';
  }

  $('#primary-add-in-selected-text-accordion').text(
    selectedPrimaryAddInText === 'None' ? 'No Add-Ins' : `${addInType}: ${selectedPrimaryAddInText}`
  );

  selectedPrimaryAddIn = this.id;
  previousPrimaryAddIn = selectedPrimaryAddIn;

  setPrice();
});

function getAddInTypeFromId(elementId) {
  // Check for none variants first
  if (elementId.includes('gemstone-none')) return "none";
  if (elementId.includes('metal-none')) return "none";
  if (elementId.includes('glow-none')) return "none";

  // Then check for actual types
  if (elementId.includes('gemstone')) return "gemstone";
  if (elementId.includes('metal')) return "metal";
  if (elementId.includes('glow')) return "glow";

  return "none";
}

function updateSecondaryAddInOptions(primaryType) {
  var secondaryGemInputs = $('input[id^="secondary-gemstone-"]');
  var secondaryMetalInputs = $('input[id^="secondary-metal-"]');
  var secondaryGlowInputs = $('input[id^="secondary-glow-"]');

  // For Split Color and Dynamic Split, allow all combinations
  if (selectedColoration === "Split Color" || selectedColoration === "Dynamic Split") {
    secondaryGemInputs.prop('disabled', false);
    secondaryMetalInputs.prop('disabled', false);
    secondaryGlowInputs.prop('disabled', false);
    return;
  }

  // First disable everything
  secondaryGemInputs.prop('disabled', true);
  secondaryMetalInputs.prop('disabled', true);
  secondaryGlowInputs.prop('disabled', true);

  // Enable based on primary type
  if (primaryType === 'gemstone' || primaryType === 'metal') {
    secondaryGemInputs.prop('disabled', false);
    secondaryMetalInputs.prop('disabled', false);
    secondaryGlowInputs.prop('disabled', true);
  } else if (primaryType === 'glow') {
    // Enable all glows except none
    secondaryGlowInputs.prop('disabled', false);
    $('#secondary-glow-none').prop('disabled', true);

    // Only auto-select matching glow if current selection isn't already a glow
    var currentSecondary = $('input[name="properties[Secondary AddIn]"]:checked');
    if (!currentSecondary.length || !currentSecondary.attr('id').includes('glow')) {
      const primaryGlowId = $('input[name="properties[Primary AddIn]"]:checked').attr('id');
      const matchingSecondaryId = primaryGlowId.replace('primary-', 'secondary-');
      if ($('#' + matchingSecondaryId).length) {
        programmaticClick(document.getElementById(matchingSecondaryId));
      }
    }
  } else if (primaryType === 'none') {
    secondaryGemInputs.prop('disabled', false);
    secondaryMetalInputs.prop('disabled', false);
    secondaryGlowInputs.prop('disabled', false);
  }

  handleSecondaryTypeMismatch(primaryType);
}

function handleSecondaryTypeMismatch(primaryType) {
  // Skip for Split Color and Dynamic Split
  if (selectedColoration === "Split Color" || selectedColoration === "Dynamic Split") {
    return;
  }

  var selectedSecondary = $('input[name="properties[Secondary AddIn]"]:checked');
  if (!selectedSecondary.length) return;

  var currentSecondaryId = selectedSecondary.attr('id');
  var shouldReset = false;

  // Handle glow type mismatches
  if (primaryType === 'glow') {
    if (!currentSecondaryId.includes('glow')) {
      const primaryGlowId = $('input[name="properties[Primary AddIn]"]:checked').attr('id');
      const matchingSecondaryId = primaryGlowId.replace('primary-', 'secondary-');
      programmaticClick(document.getElementById(matchingSecondaryId));
      shouldReset = true;
    }
  } else if (primaryType !== 'glow' && currentSecondaryId.includes('glow')) {
    programmaticClick(document.getElementById('secondary-gemstone-none'));
    shouldReset = true;
  }

  if (shouldReset) {
    console.warn('Add-in type mismatch reset:', primaryType);
}
}

$('input[type=radio][name="properties[Secondary AddIn]"]').on('change', function() {
  secondaryAddInHex = $(this).attr('color-hex') || "#00000000";
  if (selectedColoration === "Marble") {
    $("#SparkleGradientMarble .stop1, #SparkleGradientMarble .stop2").css("stop-color", secondaryAddInHex);
  } else {
    $("#SparkleGradientBase .stop1, #SparkleGradientBase .stop2,  .addinfadestop2").css("stop-color", secondaryAddInHex);
  }
  if (isProgrammaticChange) return;

  secondaryAddInType = getAddInTypeFromId(this.id);
  let selectedSecondaryAddInText = this.value.replace(/(Gemstones|Glow|Metals)$/, '').trim();
  let addInType = '';


  if ($(this).attr('id').includes('gemstone')) {
    addInType = 'Gemstone';
  } else if ($(this).attr('id').includes('metal')) {
    addInType = 'Metal';
  } else if ($(this).attr('id').includes('glow')) {
    addInType = 'Glow';
  }

  $('#secondary-add-in-selected-text-accordion').text(
    selectedSecondaryAddInText === 'None' ? 'No Add-Ins' : `${addInType}: ${selectedSecondaryAddInText}`
  );

  selectedSecondaryAddIn = this.id;
  previousSecondaryAddIn = selectedSecondaryAddIn;

  setPrice();
});

$('input[type=radio][name="properties[Model]"]').on('change', function() {
  if (isProgrammaticChange) return;

selectedModel = this.value;

handleModelChange();

});

function handleModelChange() {

  if (window.location.pathname.includes('brooklyn-supreme')) {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
    document.getElementById("standard-size-div").style.display = "none";
    document.getElementById("one-size-div").style.display = "none";
    programmaticClick(document.getElementById("size-brooklyn-supreme"));
    document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
  }

  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt' || selectedModel == 'Kaleb Butt') {

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"

      programmaticClick(document.getElementById("firmness-super-soft"));
      programmaticClick(document.getElementById("size-penetrable"));
      programmaticClick(document.getElementById("suction-cup-na"));


  }else{

      previousModel = selectedModel;

      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ programmaticClick(document.getElementById("firmness-soft")); }
        if (previousFirmness == "Medium"){ programmaticClick(document.getElementById("firmness-medium")); }
        if (previousFirmness == "Firm"){ programmaticClick(document.getElementById("firmness-firm")); }

        if (previousSize == "Mini"){ programmaticClick(document.getElementById("size-mini")); }
        if (previousSize == "Small"){ programmaticClick(document.getElementById("size-small")); }
        if (previousSize == "Medium"){ programmaticClick(document.getElementById("size-medium")); }
        if (previousSize == "Large"){ programmaticClick(document.getElementById("size-large")); }
        if (previousSize == "XL"){ programmaticClick(document.getElementById("size-xl")); }
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ programmaticClick(document.getElementById("size-brooklyn-supreme")); }

        if (previousSuctionCup == "No"){ programmaticClick(document.getElementById("suction-cup-no")); }
        if (previousSuctionCup == "Yes"){ programmaticClick(document.getElementById("suction-cup-yes")); }

      }


  }

  if (selectedModel == 'Atlas') {
    // Show Brooklyn Supreme option for Atlas, but don't force it
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  } else {
    // For non-Atlas models, hide Brooklyn Supreme and reset if needed
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (selectedSize == 'Brooklyn Supreme') {
      // Reset to previous non-Brooklyn Supreme size
      if (previousSize == "Mini"){ programmaticClick(document.getElementById("size-mini")); }
      if (previousSize == "Small"){ programmaticClick(document.getElementById("size-small")); }
      if (previousSize == "Medium"){ programmaticClick(document.getElementById("size-medium")); }
      if (previousSize == "Large"){ programmaticClick(document.getElementById("size-large")); }
      if (previousSize == "XL"){ programmaticClick(document.getElementById("size-xl")); }
    }
  }



  checkSuctionCup();

  setPrice();
};

$('input[type=radio][name="properties[Size]"]').on('change', function() {
  if (isProgrammaticChange) return;

  selectedSize = this.value;

    if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

      if (selectedModel == "Atlas"){
        if (selectedSize == "Brooklyn Supreme"){
          document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
        }else{
          document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
        }
      }

    checkSuctionCup();

  setPrice();
});

$('input[type=radio][name="properties[Firmness]"]').on('change', function() {
  if (isProgrammaticChange) return;

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }

  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {
  if (isProgrammaticChange) return;

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }

  setPrice();
});

$('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {
  if (isProgrammaticChange) return;

  selectedExtra = this.value;

  checkSuctionCup();

  setPrice();
});

function handleAddInReselection(coloration) {
  if (!customColorations.includes(coloration)) {
    // Reset state variables when switching to non-custom coloration
    selectedPrimaryAddIn = "None";
    selectedSecondaryAddIn = "None";
    primaryAddInType = "none";
    secondaryAddInType = "none";
    return;
  }

  try {
    isProgrammaticChange = true;
    // Restore primary add-in first and update state
    if (previousPrimaryAddIn) {
      selectedPrimaryAddIn = previousPrimaryAddIn;
      primaryAddInType = getAddInTypeFromId(previousPrimaryAddIn);
      const primaryElement = document.getElementById(previousPrimaryAddIn);
      if (primaryElement) {
        primaryElement.click();
        // Let rules update before handling secondary
        setTimeout(() => {
          // Only restore secondary for multi-color options
          if (coloration !== "Solid Color" && previousSecondaryAddIn) {
            selectedSecondaryAddIn = previousSecondaryAddIn;
            secondaryAddInType = getAddInTypeFromId(previousSecondaryAddIn);
            const secondaryElement = document.getElementById(previousSecondaryAddIn);
            if (secondaryElement) {
              secondaryElement.click();
            }
          }
          isProgrammaticChange = false;
          setPrice();
        }, 0);
      }
    }
  } catch (error) {
    console.error('Error in handleAddInReselection:', error);
    isProgrammaticChange = false;
    // Reset state on error
    selectedPrimaryAddIn = "None";
    selectedSecondaryAddIn = "None";
    primaryAddInType = "none";
    secondaryAddInType = "none";
  }
}





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-model"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedCumTube = "No";
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";

  var primaryColor = "#ffffff";
  var secondaryColor = "#ffffff";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
     


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }

      if (selectedCumTube == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 30;
        }else{
          price += 20;
        }
      }

      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();
    
  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();
  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

 $(document).ready(function() {

   colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));


   setPrice();

   $(".cls-0").css("fill", primaryColor);
    $(".cls-1").css("fill", secondaryColor);
    $(".cls-2").css("fill", secondaryColor);

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  if ($(this).attr('coloration-image') == "none"){
    document.getElementById("coloration_svg").style.display = "block";
    document.getElementById("colorationImage").style.display = "none";
    

     if (selectedColoration == "Solid Color") {
       $(".cls-0").css("fill", primaryColor);
      $("#marble,#base").css("display", "none");
       document.getElementById("ButtonSet-Color-Primary").style.display = "block";
      document.getElementById("ButtonSet-Color-Secondary").style.display = "none";
    }else if(selectedColoration == "Split Color" || selectedColoration == "Dynamic Split") {
       $(".cls-0").css("fill", primaryColor);
        $(".cls-1").css("fill", secondaryColor);
        $(".cls-2").css("fill", secondaryColor);
      $("#marble").css("display", "none");
      $("#base").css("display", "block");
       document.getElementById("ButtonSet-Color-Primary").style.display = "block";
      document.getElementById("ButtonSet-Color-Secondary").style.display = "block";
    } else if(selectedColoration == "Fade") {
       $(".cls-0").css("fill", "url(#Gradient)");
      $(".stop1").css("stop-color", primaryColor);
      $(".stop2").css("stop-color", secondaryColor);
      $("#marble,#base").css("display", "none");
       document.getElementById("ButtonSet-Color-Primary").style.display = "block";
      document.getElementById("ButtonSet-Color-Secondary").style.display = "block";
    } else if( selectedColoration == "Marble") {
       $(".cls-0").css("fill", primaryColor);
        $(".cls-1").css("fill", secondaryColor);
        $(".cls-2").css("fill", secondaryColor);
      $("#base").css("display", "none");
      $("#marble").css("display", "block");
       document.getElementById("ButtonSet-Color-Primary").style.display = "block";
      document.getElementById("ButtonSet-Color-Secondary").style.display = "block";
    } 
    
  }else{
    document.getElementById("coloration_svg").style.display = "none";
    document.getElementById("colorationImage").style.display = "inline-block";
    document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
    document.getElementById("ButtonSet-Color-Primary").style.display = "none";
    document.getElementById("ButtonSet-Color-Secondary").style.display = "none";


  }

  
  
  setPrice();
});

$('input[type=radio][name="properties[Primary Color]"]').on('change', function() {

    primaryColor = $(this).attr('color-hex');
  
  if (selectedColoration == "Fade") {
    $(".cls-0").css("fill", "url(#Gradient)");
    $(".stop1").css("stop-color",  $(this).attr('color-hex'));
  }else{
    $(".cls-0").css("fill", $(this).attr('color-hex') );
  }
});

$('input[type=radio][name="properties[Secondary Color]"]').on('change', function() {

  secondaryColor = $(this).attr('color-hex');
  
  if (selectedColoration == "Fade") {
    $(".cls-0").css("fill", "url(#Gradient)");
    $(".stop2").css("stop-color",  $(this).attr('color-hex'));
  }else{
    $(".cls-1").css("fill", $(this).attr('color-hex'));
    $(".cls-2").css("fill", $(this).attr('color-hex'));
  }
  
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

  
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});

$('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

  selectedCumTube = this.value;

  checkSuctionCup();
  
  setPrice(); 
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-multiple-colorations-bf"]) return;
  try {
    

var isProgrammaticChange = false;

var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedAddIn = "None";
var selectedSuctionCup = "No";
var selectedCumTube = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";
var previousCumTube = "No";


var sizeChart = document.getElementById("size-chart-aela");
var colorationPrice = 0;

$(document).ready(function() {

  colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value')) || 0;
  document.getElementById("coloration-0").click();
  document.getElementById("model-1").click();
  document.getElementById("size-mini").click();
  document.getElementById("firmness-medium").click();
  document.getElementById("cum-tube-no").click();
  document.getElementById("suction-cup-no").click();

  const preloadedColorationImages = preloadColorationImages();

  checkCumTube();

  setPrice();

});

function preloadColorationImages() {
  // Get all coloration radio inputs
  const colorations = document.querySelectorAll('input[name="properties[Coloration]"]');
  const preloadedImages = {};

  // Iterate through each coloration option
  colorations.forEach(coloration => {
    const imageUrl = coloration.getAttribute('coloration-image');
    if (imageUrl) {
      // Create a new image object and set its src to preload the image
      const img = new Image();
      img.src = imageUrl;
      // Store the preloaded image reference with the coloration name as key
      preloadedImages[coloration.value] = img;
    }
  });

  return preloadedImages;
}

function setPrice() {

  var price = 0;


  price += colorationPrice;


  if (selectedModel == "Serenity"){
    price += 75;
  }else if (selectedModel == "Zane Butt"){
    price += 100;
  }else if (selectedModel == "Kaleb Butt"){
    price += 100;
  }else if (selectedModel == "Jake"){
    if (selectedSize == "Mini"){
      price += 50;
    }else if (selectedSize == "Small"){
      price += 60;
    }else if (selectedSize == "Medium"){
      price += 80;
    }else if (selectedSize == "Large"){
      price += 100;
    }else if (selectedSize == "XL"){
      price += 120;
    }
  } else{
    if (selectedSize == "Mini"){
      price += 65;
    }else if (selectedSize == "Small"){
      price += 85;
    }else if (selectedSize == "Medium"){
      price += 110;
    }else if (selectedSize == "Large"){
      price += 150;
    }else if (selectedSize == "XL"){
      price += 200;
    }else if (selectedSize == "Brooklyn Supreme"){
      price += 400;
    }
  }

      if (selectedAddIn == "None") {
    price += 0;
  } else if (selectedAddIn.includes("Gemstone")) {
    price += 5;
  } else if (selectedAddIn.includes("Metals")) {
    price += 5;
  } else if (selectedAddIn.includes("Glow")) {
    price += 10;
  }

  if (selectedCumTube == "Yes") {
    if (selectedSize == "Brooklyn Supreme"){
      price += 30;
    }else{
      price += 20;
    }
  }

  if (selectedSuctionCup == "Yes") {
    if (selectedSize == "Brooklyn Supreme"){
      price += 10;
    }else{
      price += 5;
    }

  }

  if (price <= 300){
    document.getElementById("option-0-" + ((price - 50)/5) + "").click();
  }else if (price >= 400 && price <= 500) {
    document.getElementById("option-0-" + ((price - 145)/5) + "").click();
  }else{
    document.getElementById("option-0-71").click();
  }

}



//CumTube Availability Support

function checkCumTube() {

  for (const index in cumTubeSupport) {

  var model = cumTubeSupport[index];
  var modelName = model["name"] ;

  if (modelName == selectedModel){
    if (model.cumTubeAllowed == true) {

        if (selectedCumTube == "N/A") {
          document.getElementById("standard-cum-tube-div").style.display = "block";
          document.getElementById("cum-tube-na-div").style.display = "none";
          if (previousCumTube == "No"){ document.getElementById("cum-tube-no").click(); }
          if (previousCumTube == "Yes"){ document.getElementById("cum-tube-yes").click(); }
        }
      break;

      } else {
        document.getElementById("standard-cum-tube-div").style.display = "none";
        document.getElementById("cum-tube-na-div").style.display = "block";
        document.getElementById("cum-tube-na").click();
        break;
      }

    }else{
      document.getElementById("standard-cum-tube-div").style.display = "none";
      document.getElementById("cum-tube-na-div").style.display = "block";
      document.getElementById("cum-tube-na").click();
    }
  }

  checkSuctionCup();
}


function checkSuctionCup() {

  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();

  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();

  } else {
      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); }
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); }
    }
  }
}




$('input[type=radio][name="properties[Coloration]"]').on('change', function() {
  selectedColoration = this.value;
  colorationPrice = Number($(this).attr('data-value'));

  // Fade out, change source, then fade in
  const colorationImage = document.getElementById("colorationImage");
  colorationImage.style.opacity = "0";

  setTimeout(() => {
    colorationImage.src = $(this).attr('coloration-image');
    colorationImage.style.opacity = "1";
  }, 300);

  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {

  selectedModel = this.value;
  var modelId = selectedModel.toLowerCase().replace(/ /g, '-');

  // Hide all size charts first
  document.querySelectorAll('[id^="size-chart-"]').forEach(function(chart) {
    chart.style.display = 'none';
  });

  // Show selected model's size chart
  var sizeChart = document.getElementById('size-chart-' + modelId);
  if (sizeChart) {
    sizeChart.style.display = 'block';
  }

  // Update model image
  if (selectedModel == 'Atlas' && selectedSize == 'Brooklyn Supreme') {
    document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
  } else {
    const modelImage = $(this).data('model-image');
    if (modelImage) {
      document.getElementById("modelImage").src = modelImage;
    }
  }

  if (selectedModel !== previousModel) {
    previousModel = selectedModel;
  }

  handleModelChange();
});

function handleModelChange() {
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt' || selectedModel == 'Kaleb Butt') {

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"

      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();


  }else{

      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); }
        if (previousSize == "Large"){ document.getElementById("size-large").click(); }
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); }
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); }

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); }
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); }

      }
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  } else {
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (selectedSize == 'Brooklyn Supreme') {
      // Reset to previous non-Brooklyn Supreme size
      if (previousSize == "Mini") programmaticClick(document.getElementById("size-mini"));
      if (previousSize == "Small") programmaticClick(document.getElementById("size-small"));
      if (previousSize == "Medium") programmaticClick(document.getElementById("size-medium"));
      if (previousSize == "Large") programmaticClick(document.getElementById("size-large"));
      if (previousSize == "XL") programmaticClick(document.getElementById("size-xl"));
    }
  }

  checkCumTube();

  setPrice();
}


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

 checkCumTube();

  setPrice();
});


$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }

  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }

  setPrice();
});


$('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

selectedCumTube = this.value;

if (selectedCumTube != "N/A"){ previousCumTube = selectedCumTube }

checkSuctionCup();

setPrice();
});

function programmaticClick(element) {
  if (!element) return;
  isProgrammaticChange = true;
  element.click();
  isProgrammaticChange = false;
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-multiple-colorations"]) return;
  try {
    

var isProgrammaticChange = false;

var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedAddIn = "None";
var selectedSuctionCup = "No";
var selectedCumTube = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";
var previousCumTube = "No";


var sizeChart = document.getElementById("size-chart-aela");
var colorationPrice = 0;

$(document).ready(function() {

  colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value')) || 0;
  document.getElementById("coloration-0").click();
  document.getElementById("model-1").click();
  document.getElementById("size-mini").click();
  document.getElementById("firmness-medium").click();
  document.getElementById("cum-tube-no").click();
  document.getElementById("suction-cup-no").click();

  const preloadedColorationImages = preloadColorationImages();

  checkCumTube();

  setPrice();

});

function preloadColorationImages() {
  // Get all coloration radio inputs
  const colorations = document.querySelectorAll('input[name="properties[Coloration]"]');
  const preloadedImages = {};

  // Iterate through each coloration option
  colorations.forEach(coloration => {
    const imageUrl = coloration.getAttribute('coloration-image');
    if (imageUrl) {
      // Create a new image object and set its src to preload the image
      const img = new Image();
      img.src = imageUrl;
      // Store the preloaded image reference with the coloration name as key
      preloadedImages[coloration.value] = img;
    }
  });

  return preloadedImages;
}

function setPrice() {

  var price = 0;


  price += colorationPrice;


  if (selectedModel == "Serenity"){
    price += 75;
  }else if (selectedModel == "Zane Butt"){
    price += 100;
  }else if (selectedModel == "Kaleb Butt"){
    price += 100;
  }else if (selectedModel == "Jake"){
    if (selectedSize == "Mini"){
      price += 50;
    }else if (selectedSize == "Small"){
      price += 60;
    }else if (selectedSize == "Medium"){
      price += 80;
    }else if (selectedSize == "Large"){
      price += 100;
    }else if (selectedSize == "XL"){
      price += 120;
    }
  } else{
    if (selectedSize == "Mini"){
      price += 65;
    }else if (selectedSize == "Small"){
      price += 85;
    }else if (selectedSize == "Medium"){
      price += 110;
    }else if (selectedSize == "Large"){
      price += 150;
    }else if (selectedSize == "XL"){
      price += 200;
    }else if (selectedSize == "Brooklyn Supreme"){
      price += 400;
    }
  }

      if (selectedAddIn == "None") {
    price += 0;
  } else if (selectedAddIn.includes("Gemstone")) {
    price += 5;
  } else if (selectedAddIn.includes("Metals")) {
    price += 5;
  } else if (selectedAddIn.includes("Glow")) {
    price += 10;
  }

  if (selectedCumTube == "Yes") {
    if (selectedSize == "Brooklyn Supreme"){
      price += 30;
    }else{
      price += 20;
    }
  }

  if (selectedSuctionCup == "Yes") {
    if (selectedSize == "Brooklyn Supreme"){
      price += 10;
    }else{
      price += 5;
    }

  }

  if (price <= 300){
    document.getElementById("option-0-" + ((price - 50)/5) + "").click();
  }else if (price >= 400 && price <= 500) {
    document.getElementById("option-0-" + ((price - 145)/5) + "").click();
  }else{
    document.getElementById("option-0-71").click();
  }

}



//CumTube Availability Support

function checkCumTube() {

  for (const index in cumTubeSupport) {

  var model = cumTubeSupport[index];
  var modelName = model["name"] ;

  if (modelName == selectedModel){
    if (model.cumTubeAllowed == true) {

        if (selectedCumTube == "N/A") {
          document.getElementById("standard-cum-tube-div").style.display = "block";
          document.getElementById("cum-tube-na-div").style.display = "none";
          if (previousCumTube == "No"){ document.getElementById("cum-tube-no").click(); }
          if (previousCumTube == "Yes"){ document.getElementById("cum-tube-yes").click(); }
        }
      break;

      } else {
        document.getElementById("standard-cum-tube-div").style.display = "none";
        document.getElementById("cum-tube-na-div").style.display = "block";
        document.getElementById("cum-tube-na").click();
        break;
      }

    }else{
      document.getElementById("standard-cum-tube-div").style.display = "none";
      document.getElementById("cum-tube-na-div").style.display = "block";
      document.getElementById("cum-tube-na").click();
    }
  }

  checkSuctionCup();
}


function checkSuctionCup() {

  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();

  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();

  } else {
      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); }
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); }
    }
  }
}




$('input[type=radio][name="properties[Coloration]"]').on('change', function() {
  selectedColoration = this.value;
  colorationPrice = Number($(this).attr('data-value'));

  // Fade out, change source, then fade in
  const colorationImage = document.getElementById("colorationImage");
  colorationImage.style.opacity = "0";

  setTimeout(() => {
    colorationImage.src = $(this).attr('coloration-image');
    colorationImage.style.opacity = "1";
  }, 300);

  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {

  selectedModel = this.value;
  var modelId = selectedModel.toLowerCase().replace(/ /g, '-');

  // Hide all size charts first
  document.querySelectorAll('[id^="size-chart-"]').forEach(function(chart) {
    chart.style.display = 'none';
  });

  // Show selected model's size chart
  var sizeChart = document.getElementById('size-chart-' + modelId);
  if (sizeChart) {
    sizeChart.style.display = 'block';
  }

  // Update model image
  if (selectedModel == 'Atlas' && selectedSize == 'Brooklyn Supreme') {
    document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
  } else {
    const modelImage = $(this).data('model-image');
    if (modelImage) {
      document.getElementById("modelImage").src = modelImage;
    }
  }

  if (selectedModel !== previousModel) {
    previousModel = selectedModel;
  }

  handleModelChange();
});

function handleModelChange() {
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt' || selectedModel == 'Kaleb Butt') {

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"

      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();


  }else{

      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); }
        if (previousSize == "Large"){ document.getElementById("size-large").click(); }
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); }
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); }

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); }
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); }

      }
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  } else {
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (selectedSize == 'Brooklyn Supreme') {
      // Reset to previous non-Brooklyn Supreme size
      if (previousSize == "Mini") programmaticClick(document.getElementById("size-mini"));
      if (previousSize == "Small") programmaticClick(document.getElementById("size-small"));
      if (previousSize == "Medium") programmaticClick(document.getElementById("size-medium"));
      if (previousSize == "Large") programmaticClick(document.getElementById("size-large"));
      if (previousSize == "XL") programmaticClick(document.getElementById("size-xl"));
    }
  }

  checkCumTube();

  setPrice();
}


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

 checkCumTube();

  setPrice();
});


$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }

  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }

  setPrice();
});


$('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

selectedCumTube = this.value;

if (selectedCumTube != "N/A"){ previousCumTube = selectedCumTube }

checkSuctionCup();

setPrice();
});

function programmaticClick(element) {
  if (!element) return;
  isProgrammaticChange = true;
  element.click();
  isProgrammaticChange = false;
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pride-colorations"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedCumTube = "No";
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousCumTube = "No";
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }

      if (selectedCumTube == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 30;
        }else{
          price += 20;
        }
      }
  
      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkCumTube() {

  for (const index in modelSupport) {
    
    var model = modelSupport[index];
    var modelName = model["name"] ;

    if (modelName == selectedModel){
      if (model.cumTubeAllowed == true) {
        if (selectedCumTube == "N/A") {
          document.getElementById("standard-cum-tube-div").style.display = "block";
          document.getElementById("cum-tube-na-div").style.display = "none";
          if (previousCumTube == "No"){ document.getElementById("cum-tube-no").click(); } 
          if (previousCumTube == "Yes"){ document.getElementById("cum-tube-yes").click(); } 
        }
      } else {
        document.getElementById("standard-cum-tube-div").style.display = "none";
        document.getElementById("cum-tube-na-div").style.display = "block";
        document.getElementById("cum-tube-na").click();
      }
      
    }else{
      document.getElementById("standard-cum-tube-div").style.display = "none";
      document.getElementById("cum-tube-na-div").style.display = "block";
      document.getElementById("cum-tube-na").click();
    }
  }
}
  

function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();
  } else if (selectedCumTube == "Yes" && (selectedSize == "Mini" || selectedSize == "Small")) {
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
      document.getElementById("suction-cup-na").click();
  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

function updatePricing() {
  var ele = document.getElementsByName('properties[Model]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedModel = ele[i].value;
    
  }

  //console.log("Selected Model: " + selectedModel);
  
  ele = document.getElementsByName('properties[Size]');

  for (i = 0; i < ele.length; i++) {
      if (ele[i].checked)
        selectedSize = ele[i].value;
  }

  setPrice();
}
 

  
  
 $(document).ready(function() {

   //colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));

   document.getElementById("model-1").click();
   document.getElementById("size-mini").click();
   document.getElementById("firmness-medium").click();
   document.getElementById("cum-tube-no").click();
   document.getElementById("suction-cup-no").click();
    
  setInterval(updatePricing, 500);

  checkCumTube();

   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-ember").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-ian").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
    case "Ember":
      document.getElementById("size-chart-ember").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ark-small.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Ian":
      document.getElementById("size-chart-ian").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/animated_Ian2.png";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 




  checkCumTube();
  
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});

  $('input[type=radio][name="properties[Cum Tube]"]').on('change', function() {

  selectedCumTube = this.value;

  if (selectedCumTube != "N/A"){ previousCumTube = selectedCumTube }

  checkSuctionCup();
  
  setPrice(); 
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-zodiac-november"]) return;
  try {
    
  
var selectedModel = "Aela";
var selectedSize = "Mini";
var selectedFirmness = "Medium";
var selectedColoration = "For-Science!"
var selectedSuctionCup = "No";

var previousModel = "Aela";
var previousSize = "Mini";
var previousFirmness = "Medium";
var previousColoration = "For-Science!"
var previousSuctionCup = "No";

var colorationPrice = 0;

function setPrice() {
 
    var price = 0;


    price += colorationPrice;


      if (selectedModel == "Serenity"){
        price += 75;
      }else if (selectedModel == "Zane Butt"){
        price += 100;
      }else if (selectedModel == "Jake"){
        if (selectedSize == "Mini"){
          price += 50;
        }else if (selectedSize == "Small"){
          price += 60;
        }else if (selectedSize == "Medium"){
          price += 80;
        }else if (selectedSize == "Large"){
          price += 100;
        }else if (selectedSize == "XL"){
          price += 120;
        }
      } else{
        if (selectedSize == "Mini"){
          price += 65;
        }else if (selectedSize == "Small"){
          price += 85;
        }else if (selectedSize == "Medium"){
          price += 110;
        }else if (selectedSize == "Large"){
          price += 150; 
        }else if (selectedSize == "XL"){
          price += 200;
        }else if (selectedSize == "Brooklyn Supreme"){
          price += 400; 
        }
      }




  
      if (selectedColoration == "Marble" ) {
          price = 15;
      }else if (selectedColoration == "Fade" ) {
          price = 20;
      }else if (selectedColoration == "Rainbow Ribbon Wave") {
          price = 45;
      }else if (selectedColoration == "Rainbow Vein") {
          price = 50;
      }else if (selectedColoration.includes("Vein") || selectedColoration == "Opal") {
          price = 20;
      }else if (selectedColoration.includes("Zodiac Fade") ) {
          price = 20;
      }


      if (selectedColoration.includes("Natural") || selectedColoration.includes("Signature Coloration")) {

          switch(selectedModel) {
            case "Ash":
              price = 20;
              break;
            case "Mocha":
              price = 25;
              break;

            default:
              break;
          }      
      }


      if (selectedSuctionCup == "Yes") {
        if (selectedSize == "Brooklyn Supreme"){
          price += 10;
        }else{
          price += 5;
        }
        
      }
      

      

      if (price <= 300){
        document.getElementById("option-0-" + ((price - 50)/5) + "").click(); 
      }else if (price >= 400 && price <= 500) {
        document.getElementById("option-0-" + ((price - 145)/5) + "").click(); 
      }else{
        document.getElementById("option-0-71").click(); 
      } 
       


  
}


function checkSuctionCup() {

  
  if (selectedModel == "Jake" && (selectedSize == "Mini" || selectedSize == "Small")){

      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";

      document.getElementById("suction-cup-na").click();

  } else {

      if (selectedSuctionCup == "N/A" && selectedSize != "One Size"){
        document.getElementById("standard-suction-cup-div").style.display = "block";
        document.getElementById("suction-cup-na-div").style.display = "none";
        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
      }
    
  }
}

 $(document).ready(function() {

   colorationPrice = Number(document.getElementById("coloration-0").getAttribute('data-value'));


   setPrice();

     

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";

      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 

 

});


$('input[type=radio][name="properties[Coloration]"]').on('change', function() {

  selectedColoration = this.value;

  colorationPrice = Number($(this).attr('data-value'));

  document.getElementById("colorationImage").src = $(this).attr('coloration-image'); 
  
  setPrice();
});


$('input[type=radio][name="properties[Model]"]').on('change', function() {


  selectedModel = this.value;
  
  if (selectedModel == 'Serenity' || selectedModel == 'Zane Butt'){
    
      document.getElementById("standard-suction-cup-div").style.display = "none";
      document.getElementById("suction-cup-na-div").style.display = "block";
    

      document.getElementById("standard-firmness-div").style.display = "none";
      document.getElementById("super-soft-div").style.display = "block";

      document.getElementById("standard-size-div").style.display = "none";
      document.getElementById("one-size-div").style.display = "block"
      
      document.getElementById("firmness-super-soft").click();
      document.getElementById("size-penetrable").click();
      document.getElementById("suction-cup-na").click();

    
  }else{

      previousModel = selectedModel;
     
      document.getElementById("standard-suction-cup-div").style.display = "block";
      document.getElementById("suction-cup-na-div").style.display = "none";

      document.getElementById("standard-firmness-div").style.display = "block";
      document.getElementById("super-soft-div").style.display = "none";

      document.getElementById("standard-size-div").style.display = "block";
      document.getElementById("one-size-div").style.display = "none"

      if (selectedFirmness == "Super Soft"){
        if (previousFirmness == "Soft"){ document.getElementById("firmness-soft").click(); }
        if (previousFirmness == "Medium"){ document.getElementById("firmness-medium").click(); }
        if (previousFirmness == "Firm"){ document.getElementById("firmness-firm").click(); }   

        if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
        if (previousSize == "Small"){ document.getElementById("size-small").click(); }
        if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
        if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
        if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
        if (previousSize == "Brooklyn Supreme" && previousModel == "Atlas"){ document.getElementById("size-brooklyn-supreme").click(); } 

        if (previousSuctionCup == "No"){ document.getElementById("suction-cup-no").click(); } 
        if (previousSuctionCup == "Yes"){ document.getElementById("suction-cup-yes").click(); } 
        
      }

    
  }

  if (selectedModel == 'Atlas') {
    document.getElementById("brooklyn-supreme-div").style.display = "block";
  }else if (selectedSize == 'Brooklyn Supreme'){
    document.getElementById("brooklyn-supreme-div").style.display = "none";
    if (previousSize == "Mini"){ document.getElementById("size-mini").click(); }
    if (previousSize == "Small"){ document.getElementById("size-small").click(); }
    if (previousSize == "Medium"){ document.getElementById("size-medium").click(); } 
    if (previousSize == "Large"){ document.getElementById("size-large").click(); } 
    if (previousSize == "XL"){ document.getElementById("size-xl").click(); } 
    
  }else{
    document.getElementById("brooklyn-supreme-div").style.display = "none";
  }
  

          
  document.getElementById("size-chart-aela").style.display = "none";
  document.getElementById("size-chart-alto").style.display = "none";
  document.getElementById("size-chart-ash").style.display = "none";
  document.getElementById("size-chart-atlas").style.display = "none";
  document.getElementById("size-chart-cortez").style.display = "none";
  document.getElementById("size-chart-croxic").style.display = "none";
  document.getElementById("size-chart-cyrus").style.display = "none";
  document.getElementById("size-chart-dante").style.display = "none";
  document.getElementById("size-chart-hidora").style.display = "none";
  document.getElementById("size-chart-jake").style.display = "none";
  document.getElementById("size-chart-mantis").style.display = "none";
  document.getElementById("size-chart-mocha").style.display = "none";
  document.getElementById("size-chart-serenity").style.display = "none";
  document.getElementById("size-chart-slikk").style.display = "none";
  document.getElementById("size-chart-zane").style.display = "none";
  document.getElementById("size-chart-zane-butt").style.display = "none";
  
  switch(selectedModel) {
    case "Aela":
      document.getElementById("size-chart-aela").style.display = "block"; 
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/aela.png"; 
      break;
    case "Alto":
      document.getElementById("size-chart-alto").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/alto_500918af-0059-4c32-a8e2-4b6f61aa918a.png";
      break;
    case "Ash":
      document.getElementById("size-chart-ash").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ash.png";
      break;
    case "Atlas":
      document.getElementById("size-chart-atlas").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
      break;
    case "Cortez":
      document.getElementById("size-chart-cortez").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cortez_5ab0f67b-171f-48a7-930f-f713e55bcb3a.png";
      break;
    case "Croxic":
      document.getElementById("size-chart-croxic").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/croxic_f6548aa5-f6ab-4401-af8b-f0cc24bd9e76.png";
      break;
    case "Cyrus":
      document.getElementById("size-chart-cyrus").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/cyrus3.png";
      break;
    case "Dante":
      document.getElementById("size-chart-dante").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/dante_4f2fbe7c-23aa-4fe2-b40a-afc8d72fc533.png";
      break;
    case "Hidora":
      document.getElementById("size-chart-hidora").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/hidora_0b943a40-0ad8-444f-91ba-0667d1103592.png";
      break;
    case "Jake":
      document.getElementById("size-chart-jake").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/jake_8f7b6bc1-440d-4117-90df-68260dccc526.png";
      break;
    case "Mantis":
      document.getElementById("size-chart-mantis").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mantis_94765c17-96a5-4343-a9a9-ef98909c9799.png";
      break;
    case "Mocha":
      document.getElementById("size-chart-mocha").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/mocha_863faeb8-4572-4be4-b97b-53416c13c0ed.png";
      break;
    case "Serenity":
      document.getElementById("size-chart-serenity").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/serenityReduced.png";
      break;
    case "Slikk":
      document.getElementById("size-chart-slikk").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/slikk_791ea621-b84d-4091-b9c6-82c8b2469555.png";
      break;
    case "Zane":
      document.getElementById("size-chart-zane").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/zane_0dd2c81a-26da-46fc-bb12-aaef931ec245.png";
      break;
    case "Zane Butt":
      document.getElementById("size-chart-zane-butt").style.display = "block";
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/ZaneButtReduced.png";
      break;

    default:
      break;
  } 

  
  
  checkSuctionCup();
 
  setPrice();
});


$('input[type=radio][name="properties[Size]"]').on('change', function() {

  selectedSize = this.value;

  if (selectedSize != "One Size" && selectedSize != "Brooklyn Supreme"){ previousSize = selectedSize }

  if (selectedModel == "Atlas"){
    if (selectedSize == "Brooklyn Supreme"){
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/brooklynSupreme.png";
    }else{
      document.getElementById("modelImage").src = "https://cdn.shopify.com/s/files/1/1829/9137/files/atlas_9a4cba56-f3f0-4a68-b7a9-0ff28814e6ce.png";
    }
  }

  checkSuctionCup();
  
  setPrice();
});
  
$('input[type=radio][name="properties[Firmness]"]').on('change', function() {

  selectedFirmness = this.value;

  if (selectedFirmness != "Super Soft"){ previousFirmness = selectedFirmness }
  
  setPrice();
});


$('input[type=radio][name="properties[Suction Cup]"]').on('change', function() {

  selectedSuctionCup = this.value;

  if (selectedSuctionCup != "N/A"){ previousSuctionCup = selectedSuctionCup }
  
  setPrice(); 
});





  } catch(e) { console.error(e); }
})();
})();
